/* NESW cart drawer engine.
   Extracted 2026-09-01 from sections/cart-drawer.liquid; loaded defer at the
   same section position. Liquid values arrive via window.theme.settings and
   the item-count attribute read off #cart-drawer below (both seeded by the
   residual inline script that stays in the section). */
    (function() {
    // Helper function to escape HTML and prevent XSS
    function escapeHtml(text) {
      if (!text) return '';
      /* Full escape incl. quotes: two call sites interpolate into HTML
         ATTRIBUTES (alt=, data-line-key=), where the old textContent/innerHTML
         trick left " unescaped = attribute breakout (security review
         2026-09-01). */
      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    document.addEventListener('DOMContentLoaded', function() {
      const cartTextElements = document.querySelectorAll('.cart-text');
      const cartDrawer = document.getElementById('cart-drawer');
      const closeCart = document.getElementById('close-cart');
      const cartItems = document.getElementById('cart-items');
      const cartSkeleton = document.getElementById('cart-skeleton');

      /* V2 — Low-stock badge server-truth cache. `/cart.js` never returns
         `variant_inventory_quantity`, so the JS row template can't compute the
         low-stock badge itself (the old inline logic always failed the guard
         and silently dropped the badge from every JS-built row). Instead we
         harvest the CORRECT badge HTML — rendered by Liquid `nesw-low-stock-badge`
         — from SSR rows on load and from the `/?sections=cart-drawer` re-fetch,
         keyed by variant id. The row template then replays it. Value semantics:
         a non-empty string = the `.cart-item-low-stock` wrapper HTML to emit;
         '' = confirmed NOT low-stock (emit nothing); undefined = unknown. */
      window.__neswLowStockHTML = window.__neswLowStockHTML || {};
      function __neswHarvestLowStock(root) {
        if (!root) return;
        try {
          var rows = root.querySelectorAll('.cart-item[data-variant-id]');
          for (var i = 0; i < rows.length; i++) {
            var vid = rows[i].getAttribute('data-variant-id');
            if (!vid) continue;
            var wrap = rows[i].querySelector('.cart-item-low-stock');
            var badge = wrap && wrap.querySelector('.nesw-low-stock');
            window.__neswLowStockHTML[vid] = badge ? wrap.outerHTML : '';
          }
        } catch (_) {}
      }
      /* Patch the LIVE drawer rows to match the cache (called after the
         section re-fetch harvests fresh truth). Newly-added low-stock items
         gain their badge; items no longer low-stock lose it; everything else
         is left untouched. Skips rows mid-removal so it never fights the
         rapid-delete machinery. Inserts at the SSR position: last child of
         `.cart-item-details`. */
      function __neswPatchLowStock() {
        if (!cartItems) return;
        try {
          var liveRows = cartItems.querySelectorAll('.cart-item[data-variant-id]:not([data-removing])');
          for (var i = 0; i < liveRows.length; i++) {
            var row = liveRows[i];
            var vid = row.getAttribute('data-variant-id');
            if (!vid) continue;
            var desired = window.__neswLowStockHTML[vid];
            if (typeof desired === 'undefined') continue; // unknown → leave as-is
            var existing = row.querySelector('.cart-item-low-stock');
            if (desired) {
              if (existing) { existing.outerHTML = desired; }
              else {
                var details = row.querySelector('.cart-item-details');
                if (details) details.insertAdjacentHTML('beforeend', desired);
              }
            } else if (existing) {
              existing.remove();
            }
          }
        } catch (_) {}
      }
      /* Seed the cache from the SSR rows now, BEFORE any rebuild can fire
         (all rebuild triggers are bound later in this same handler). */
      __neswHarvestLowStock(cartItems);

      /* V2 — Serialized queue for cart change requests. Rapid X-button
         clicks were firing parallel `/cart/change.js` requests; when
         their responses arrived out-of-order, the LATER response
         (which reflected a STALE cart state on the server before the
         earlier request committed) overwrote the UI total + state, so
         items appeared deleted optimistically but resurfaced on the
         next cart open. Every change request now awaits the previous
         one, guaranteeing in-order response application. */
      var cartChangeQueue = Promise.resolve();

      /* V3 bundle rail — wrap CONSECUTIVE rows sharing one data-bundle-id in a
         .cart-bgroup (red rail spelling BUNDLE + faint wash). Runs on the SSR
         markup at load and again after every full JS re-render. Moves the
         existing .cart-item nodes (listeners are delegated on #cart-items, so
         nesting them one level deeper changes nothing). Runs of ONE bundle row
         are left unwrapped — the rail needs at least two rows of height for
         the lettering, and the legacy 2px accent still covers that case. */
      /* ---- Option C: the line a bundle collapses to ----
         Everything the summary says is DERIVED from the piece rows, never
         stored twice: __applyRowPricing already refreshes data-line-price,
         data-original-line-price and data-qty on every reconcile, so refilling
         from the rows is always current and there is no second copy of the
         arithmetic to drift out of step. */
      function neswFmt() {
        return window.theme.settings.showPriceWithCurrency
          ? window.theme.settings.moneyFormatWithCurrency : window.theme.settings.moneyFormat;
      }
      function neswFillSummary(g) {
        if (!g) return;
        var sum = g.querySelector('.cart-bsum');
        var rows = [].slice.call(g.querySelectorAll('.cart-bgroup__rows .cart-item:not([data-removing])'));
        if (!sum || !rows.length) return;
        var fmt = neswFmt();

        /* 🔴 Money sums over EVERY row, but the descriptive bits dedupe by
           variant. One bundle can hold two rows of the same variant: raising the
           quantity on a bundled line makes Shopify open a SECOND line rather
           than incrementing the first (measured 2026-08-31 — tee ×1 discounted
           plus tee ×1 at full price). Both are really in the cart, so both count
           toward the price, but naming the tee twice and fanning its photo
           against itself would just look broken. */
        var titles = [], variants = [], imgs = [];
        var seenVariant = {}, seenTitle = {};
        var wasSum = 0, nowSum = 0, qtySet = {};
        rows.forEach(function (r) {
          var vid = r.dataset.variantId || '';
          var t = r.querySelector('.cart-item-title');
          var v = r.querySelector('.cart-item-variant');
          var im = r.querySelector('img');
          var tt = t ? t.textContent.trim() : '';
          if (tt && !seenTitle[tt]) { seenTitle[tt] = 1; titles.push(tt); }
          if (!seenVariant[vid]) {
            seenVariant[vid] = 1;
            if (v && v.textContent.trim()) variants.push(v.textContent.trim());
            if (im && imgs.length < 2) imgs.push(im.currentSrc || im.src);
          }
          var qty = parseInt(r.dataset.qty, 10);
          if (!(qty > 0)) qty = 1;
          qtySet[qty] = 1;
          var lineNow = parseInt(r.dataset.linePrice, 10) || 0;
          var lineWas = parseInt(r.dataset.originalLinePrice, 10) || lineNow;
          /* Compare-at wins when the merchant set one above the selling price,
             same rule as neswPriceHtml uses for a single line. */
          var cmp = (window.NESW_COMPARE_AT || {})[vid] || 0;
          if (cmp > 0 && cmp * qty > lineWas) lineWas = cmp * qty;
          wasSum += lineWas;
          nowSum += lineNow;
        });
        var qtyKeys = Object.keys(qtySet);

        var tw = sum.querySelector('[data-bsum-thumbs]');
        if (tw) {
          tw.innerHTML = '';
          imgs.forEach(function (src) {
            var i = document.createElement('img');
            i.src = src; i.alt = ''; i.loading = 'lazy'; i.decoding = 'async';
            tw.appendChild(i);
          });
          if (rows.length > 2) {
            var more = document.createElement('span');
            more.className = 'cart-bsum__more';
            more.textContent = '+' + (rows.length - 2);
            tw.appendChild(more);
          }
        }

        /* Name the pieces. Two reads fine on one line; three or more would run
           long, so name two and count the rest. */
        var te = sum.querySelector('[data-bsum-title]');
        if (te) {
          te.textContent = titles.length > 2
            ? titles.slice(0, 2).join(' + ') + ' + ' + (titles.length - 2) + ' more'
            : titles.join(' + ');
        }
        /* 🔴 The sizes stay ON the collapsed line. That is what makes collapsing
           free: shoppers check sizes in the cart, and hiding them behind the
           disclosure was the one real cost of this shape. */
        var ve = sum.querySelector('[data-bsum-variant]');
        if (ve) ve.textContent = variants.join('  ·  ');

        var pe = sum.querySelector('[data-bsum-price]');
        if (pe) {
          pe.innerHTML = (wasSum > nowSum)
            ? '<s class="cart-bsum__was">' + Shopify.formatMoney(wasSum, fmt) + '</s>' +
              '<span class="cart-bsum__now">' + Shopify.formatMoney(nowSum, fmt) + '</span>' +
              '<span class="cart-bsum__save">Save ' + Shopify.formatMoney(wasSum - nowSum, fmt) + '</span>'
            : '<span>' + Shopify.formatMoney(nowSum, fmt) + '</span>';
        }

        /* 🔴 The bundle gets the SAME stepper as any other line, not a dead
           "Qty 1" chip (Jay 2026-08-31: it "isn't editable, it's also ugly and
           doesn't look the same as the other version"). Editing it sets EVERY
           piece to that number, which is what a bundle quantity means: two
           bundles is two of each piece.
           It stays a static label only where the pieces themselves are not
           editable — the legacy pack / look lines, whose fixed composition the
           Liquid deliberately renders without an input because changing one
           would break the pack count. Read that off the rows rather than
           re-deciding it here, so the two can never disagree.
           When the pieces hold DIFFERENT quantities the lowest is shown: it is
           the number of complete bundles, and setting it levels them up. */
        var qe = sum.querySelector('[data-bsum-qty]');
        if (qe) {
          var editable = rows.length > 0 && rows.every(function (r) {
            return !!r.querySelector('.quantity-input');
          });
          var qtyVal = Math.min.apply(null, qtyKeys.map(Number));
          if (!editable) {
            qe.className = 'cart-bsum__qty cart-bsum__qty--static';
            qe.textContent = 'Qty ' + qtyVal;
          } else {
            var cur = qe.querySelector('.quantity-input');
            if (!cur) {
              qe.className = 'cart-bsum__qty cart-item-quantity';
              qe.innerHTML =
                '<input type="number" class="quantity-input" data-bsum-qtyinput value="' + qtyVal +
                  '" min="0" max="9999" aria-label="Bundle quantity">' +
                '<div class="qty-stepper">' +
                  '<button type="button" class="qty-btn qty-minus" aria-label="Decrease bundle quantity" tabindex="-1">&minus;</button>' +
                  '<button type="button" class="qty-btn qty-plus" aria-label="Increase bundle quantity" tabindex="-1">+</button>' +
                '</div>';
            } else if (document.activeElement !== cur) {
              /* Never overwrite a box the shopper is typing in. */
              cur.value = qtyVal;
            }
          }
        }

        var d = g.querySelector('[data-bdisclose]');
        if (d) {
          var collapsed = g.classList.contains('cart-bgroup--collapsed');
          d.textContent = collapsed ? 'Show the ' + rows.length + ' pieces' : 'Hide the pieces';
          d.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        }
      }
      function neswUpdateBundleSummaries() {
        if (!cartItems) return;
        [].slice.call(cartItems.querySelectorAll('.cart-bgroup')).forEach(neswFillSummary);
      }

      function neswGroupBundles() {
        if (!cartItems) return;
        var kids = [].slice.call(cartItems.children);
        var run = [], runId = null;
        function flush() {
          if (run.length >= 2) {
            var g = document.createElement('div');
            g.className = 'cart-bgroup';
            var rows = document.createElement('div');
            rows.className = 'cart-bgroup__rows';
            /* Anchor the group where the run started, BEFORE reordering. */
            cartItems.insertBefore(g, run[0]);
            /* Merch order inside the group: hero → core pieces → add-on last
               (matches the approved mockups; /cart.js returns newest-add first,
               which put the add-on on TOP). Visual reorder only — the remove /
               qty flows look rows up by key/id, never by position. */
            var roleOrder = { hero: 0, req: 1, core: 1, addon: 2 };
            run.sort(function (a, b) {
              var ra = roleOrder[a.getAttribute('data-bundle-role')];
              var rb = roleOrder[b.getAttribute('data-bundle-role')];
              return (ra == null ? 1 : ra) - (rb == null ? 1 : rb);
            });
            g.appendChild(rows);
            run.forEach(function (el) { rows.appendChild(el); });
            /* The bundle's ONE line, plus the disclosure that opens the pieces.
               Built empty here and filled by neswFillSummary, which is also what
               refreshes it after a quantity change — so there is a single place
               that decides what the summary says. Collapsed by default: that is
               the whole point of the shape. */
            var sum = document.createElement('div');
            sum.className = 'cart-bsum';
            sum.innerHTML =
              '<div class="cart-bsum__thumbs" data-bsum-thumbs aria-hidden="true"></div>' +
              '<div class="cart-bsum__meta">' +
                '<div class="cart-bsum__title" data-bsum-title></div>' +
                '<div class="cart-bsum__variant" data-bsum-variant></div>' +
                '<div class="cart-bsum__price" data-bsum-price></div>' +
              '</div>' +
              '<div class="cart-bsum__qty" data-bsum-qty></div>' +
              '<button type="button" class="cart-bsum__x" data-bsum-x aria-label="Remove bundle">&times;</button>';
            var disc = document.createElement('button');
            disc.type = 'button';
            disc.className = 'cart-bdisclose';
            disc.setAttribute('aria-expanded', 'false');
            disc.setAttribute('data-bdisclose', '');
            /* 🔴 Order is summary, rows, THEN the disclosure — the button goes
               LAST so it sits at the bottom of the bundle in both states (Jay
               2026-08-31). Placed before the rows it looked right while
               collapsed and jumped to the top of the list on expand, because
               the summary above it is the thing that hides. */
            g.insertBefore(sum, rows);
            g.appendChild(disc);
            g.classList.add('cart-bgroup--collapsed');
            neswFillSummary(g);
          }
          run = []; runId = null;
        }
        kids.forEach(function (el) {
          if (!el.getAttribute) { flush(); return; }
          if (el.classList.contains('cart-bgroup')) { flush(); return; } // already grouped
          var bid = el.getAttribute('data-bundle-id');
          if (bid) {
            if (bid === runId) { run.push(el); }
            else { flush(); runId = bid; run = [el]; }
          } else { flush(); }
        });
        flush();
      }
      neswGroupBundles(); // group the server-rendered rows

      /* Disclosure + the summary's single ×. Delegated on the persistent
         #cart-items container for the same reason the row controls are: SSR
         rows and JS-rendered rows both have to work, and both survive every
         re-render. */
      cartItems.addEventListener('click', function (e) {
        if (!e.target || !e.target.closest) return;
        var d = e.target.closest('[data-bdisclose]');
        if (d) {
          e.preventDefault();
          var g = d.closest('.cart-bgroup');
          if (g) {
            g.classList.toggle('cart-bgroup--collapsed');
            neswFillSummary(g);   /* relabels the button + flips aria-expanded */
          }
          return;
        }
        var q = e.target.closest('.cart-bsum .qty-btn');
        if (q) return;   /* the shared .qty-btn handler drives the input; the
                            change listener below carries it to the pieces */
        var x = e.target.closest('[data-bsum-x]');
        if (x) {
          e.preventDefault();
          /* 🔴 Removes the WHOLE bundle, via the existing removeBundleLines.
             It must NOT delegate to a piece row's × — that was the first
             attempt and it silently did the wrong thing: for kind="pair" the
             row handler deliberately drops just that ONE line and lets the
             discount lapse, so a × labelled "Remove bundle" removed a third of
             the bundle and left the rest at full price (measured: 3 lines went
             to 2). No confirm here either. The confirm exists to warn a shopper
             that removing ONE piece takes the others with it; on a line that
             already reads as the whole bundle there is nothing to warn about. */
          var g2 = x.closest('.cart-bgroup');
          var anyRow = g2 && g2.querySelector('.cart-bgroup__rows .cart-item:not([data-removing])');
          var bid = anyRow && anyRow.dataset.bundleId;
          if (bid) removeBundleLines(bid);
        }
      });
      /* V2 — Count of queued cart mutations still in flight. When the
         shopper spam-deletes, the UI removes rows optimistically faster
         than the server processes the queued /cart/change.js calls, so an
         INTERMEDIATE response reflects fewer deletions than the screen
         already shows — reconciling totals from it makes the price jump UP
         then back DOWN as the next response lands. We only let the LAST
         pending op (counter back to 0) reconcile the authoritative totals;
         the optimistic paint carries the in-between frames smoothly. */
      var __cartOpsPending = 0;

      /* V2 — Event delegation for cart-item × remove + quantity-input
         change. Previously addQuantityListeners() bound these directly
         to each .cart-item-remove and .quantity-input element AFTER
         updateCart re-rendered the items via the JS template. But
         openCartDrawer trusts SSR on first open (skipping updateCart
         when the cart is already correct), so SSR-rendered X buttons
         + quantity inputs never got handlers attached → silent
         click-no-op. Event delegation on the persistent #cart-items
         container works for both SSR and JS-rendered items, and
         survives any future re-render. */
      cartItems.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest && e.target.closest('.cart-item-remove');
        if (!btn) return;
        var ci = btn.closest('.cart-item');
        if (!ci) return;
        var bundleId = ci.dataset.bundleId;
        var role = ci.dataset.bundleRole;
        var kind = ci.dataset.bundleKind;
        if (bundleId) {
          /* Ignis PAIR line → drop just this line. The pair is no longer intact,
             so the discount stops and the remaining line reverts to standard
             pricing by itself. No whole-bundle confirm: there is nothing the
             shopper needs to agree to. */
          if (kind === 'pair') { queueRowRemoval(ci); return; }
          if (role === 'addon') {
            /* Optional add-on → remove just this line. The discount function
               re-prices the remaining pair to the 2-item rate automatically. */
            removeBundleLines(bundleId, { onlyKey: ci.dataset.lineKey });
            return;
          }
          /* Core (locked) bundle line → removing one removes the WHOLE bundle.
             Confirm first when the bundle spans more than one line (so the
             shopper knows they're dropping the other pieces + the savings). */
          var lineCount = cartItems.querySelectorAll('.cart-item[data-bundle-id="' + (window.CSS && CSS.escape ? CSS.escape(bundleId) : bundleId) + '"]').length;
          if (lineCount > 1) {
            neswConfirmBundleRemoval(lineCount).then(function (ok) {
              if (ok) removeBundleLines(bundleId);
            });
          } else {
            removeBundleLines(bundleId);
          }
          return;
        }
        queueRowRemoval(ci);
      });
      /* V2 — Commit a manual quantity edit on blur (focusout) AND Enter,
         not just `change`. On mobile the native `change` event for number
         inputs frequently doesn't fire when the customer taps elsewhere to
         dismiss the keyboard, so the new quantity was silently dropped
         unless they pressed Enter. `committedQty` dedupes so the same value
         never triggers two /cart/change.js calls across the focusout +
         change + Enter paths. `focusin` seeds it from the current value so
         a focus-then-blur with no change is a no-op. */
      function __cartQtyCommit(input) {
        if (!input || !input.matches || !input.matches('.cart-item .quantity-input')) return;
        var ci = input.closest('.cart-item');
        if (!ci) return;
        /* Pair-bundle rows can share a variant with an ordinary line, and
           change.js by variant id edits the FIRST match. Target the line key
           instead (change.js accepts one), same fix as the cart page. */
        var vid = (ci.dataset.bundleKind === 'pair' && ci.dataset.lineKey)
          ? ci.dataset.lineKey
          : ci.dataset.variantId;
        if (!vid) return;
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < 0) return;
        if (input.dataset.committedQty === String(v)) return;
        input.dataset.committedQty = String(v);
        /* Down to 0 = a removal → route through the batched remover so a burst of
           deletes (X's and/or minus-to-0) collapses into one snappy request. */
        if (v === 0) { queueRowRemoval(ci); return; }
        updateQuantity(vid, v);
      }
      cartItems.addEventListener('focusin', function (e) {
        var input = e.target;
        if (input && input.matches && input.matches('.cart-item .quantity-input') &&
            input.dataset.committedQty === undefined) {
          input.dataset.committedQty = input.value;
        }
      });
      /* 🔴 A bundle quantity is applied by driving each PIECE's own input and
         letting the ordinary row commit run — its queueing, optimistic paint,
         line-key targeting and reconcile all come for free. Writing a second
         cart-mutation path here is how the two would drift apart.
         Ordered before __cartQtyCommit's listener, but they never both fire:
         the summary input is not inside a .cart-item, which is what
         __cartQtyCommit matches on, and the piece inputs it dispatches to are
         not inside a .cart-bsum. */
      cartItems.addEventListener('change', function (e) {
        var input = e.target;
        if (!input || !input.classList || !input.classList.contains('quantity-input')) return;
        var sum = input.closest && input.closest('.cart-bsum');
        if (!sum) return;
        var g = sum.closest('.cart-bgroup');
        if (!g) return;
        var n = parseInt(input.value, 10);
        if (isNaN(n) || n < 0) return;
        if (n === 0) {
          /* Down to zero is a removal, and the removal path owns the animation
             and the empty-group cleanup. */
          var anyRow = g.querySelector('.cart-bgroup__rows .cart-item:not([data-removing])');
          var bid = anyRow && anyRow.dataset.bundleId;
          if (bid) removeBundleLines(bid);
          return;
        }
        /* Paint the pieces optimistically so an expanded list agrees with the
           summary immediately; the batch below is what actually commits. */
        [].slice.call(g.querySelectorAll('.cart-bgroup__rows .cart-item:not([data-removing]) .quantity-input'))
          .forEach(function (pieceInput) { pieceInput.value = n; });
        queueBundleQuantity(g, n);
      });
      cartItems.addEventListener('change', function (e) { __cartQtyCommit(e.target); });
      cartItems.addEventListener('focusout', function (e) { __cartQtyCommit(e.target); });
      cartItems.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        var input = e.target;
        if (!input || !input.matches || !input.matches('.cart-item .quantity-input')) return;
        e.preventDefault();
        __cartQtyCommit(input);
        if (input.blur) input.blur(); // dismiss the mobile keyboard
      });
      /* V2 — −/+ stepper buttons. Set the input then fire `change` so the
         existing delegated commit (__cartQtyCommit → updateQuantity) runs.
         Minus at qty 1 → 0 → Shopify removes the line (same as ×). */
      cartItems.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest && e.target.closest('.qty-btn');
        if (!btn) return;
        e.preventDefault();
        var wrap = btn.closest('.cart-item-quantity');
        var input = wrap && wrap.querySelector('.quantity-input');
        if (!input) return;
        var cur = parseInt(input.value, 10); if (isNaN(cur)) cur = 0;
        var min = parseInt(input.min, 10); if (isNaN(min)) min = 0;
        var max = parseInt(input.max, 10); if (isNaN(max)) max = 9999;
        var next = btn.classList.contains('qty-plus') ? cur + 1 : cur - 1;
        if (next < min) next = min;
        if (next > max) next = max;
        if (next === cur) return;
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      /* V2 — Free-shipping bar hides on scroll-down, returns on any scroll-up
         (Jay). Listens to the cart content scroller; toggles `.fsb-collapsed`
         on the drawer (CSS collapses `.cart-fsb--top`). */
      (function initFsbScroll() {
        var content = document.querySelector('.cart-drawer-content');
        var drawer = document.getElementById('cart-drawer');
        if (!content || !drawer) return;
        /* The card hide/show no longer changes layout (pure opacity+transform),
           so scrolling never reflows. To stop momentum-scroll jitter from
           flip-flopping the state ("randomly pops back up while scrolling
           down"), we accumulate signed scroll distance and only toggle once a
           SUSTAINED move in one direction crosses a threshold. The drawer
           class is the single source of truth so external resets (scroll-to-top
           on add) stay in sync. */
        var lastY = content.scrollTop || 0;
        var accum = 0;
        var SHOW_AT_TOP = 12;     // within 12px of top: always visible
        var HIDE_GATE = 60;       // never hide until scrolled past this
        var HIDE_THRESHOLD = 26;  // sustained down-scroll needed to hide
        var SHOW_THRESHOLD = 16;  // sustained up-scroll needed to show
        content.addEventListener('scroll', function () {
          var y = content.scrollTop;
          if (y < 0) { lastY = 0; return; }            // iOS rubber-band (top)
          /* iOS rubber-band at the BOTTOM: when you scroll to the end and the
             list bounces, scrollTop settles back a few px (reads as scroll-up)
             and wrongly re-shows the card. Ignore anything in the bottom bounce
             zone — only a real scroll-up that moves clear of the bottom counts. */
          var maxScroll = content.scrollHeight - content.clientHeight;
          if (maxScroll > 0 && y >= maxScroll - 6) { lastY = y; accum = 0; return; }
          var dy = y - lastY;
          lastY = y;
          if (dy === 0) return;
          if ((dy > 0) !== (accum > 0)) accum = 0;     // direction flip: reset
          accum += dy;
          var collapsed = drawer.classList.contains('fsb-collapsed');
          if (y <= SHOW_AT_TOP) {                       // near top: force show
            if (collapsed) drawer.classList.remove('fsb-collapsed');
            accum = 0; return;
          }
          if (!collapsed && accum > HIDE_THRESHOLD && y > HIDE_GATE) {
            drawer.classList.add('fsb-collapsed'); accum = 0;
          } else if (collapsed && accum < -SHOW_THRESHOLD) {
            drawer.classList.remove('fsb-collapsed'); accum = 0;
          }
        }, { passive: true });
      })();
      const cartTotal = document.getElementById('cart-total');
      const cartDiscountEl = document.getElementById('cart-discount');
      const cartDrawerOverlay = document.getElementById('cart-drawer-overlay');

      /* Surface any cart-level discount (auto-applied promo, sitewide
         code, etc.) above the total so the shopper isn't confused why
         their $45 line is showing as $40.50 at the bottom. Reads
         `cart.cart_level_discount_applications` (Shopify's standard
         payload from /cart.js); falls back to total_discount alone if
         no application title is present. */
      /* V3 — Free shipping threshold bar. Reads `cart.total_price`
         (POST-ALL-DISCOUNTS, including order-level codes like NESW10) so the
         bar only promises free shipping when checkout will actually give it.
         The old read of `items_subtotal_price` ignored order-level codes and
         claimed free shipping while checkout still charged the flat rate.
         Threshold matches the announcement bar copy. */
      var CART_FREE_SHIPPING_THRESHOLD_CENTS = 7500; // $75 (lowered from $100, Jay 2026-07-20)
      /* V3 — Single source of truth for the flat shipping estimate: $8.95 under
         the $100 post-discount threshold, free at/over it. */
      function neswShipCents(cart) {
        var t = (cart && typeof cart.total_price === 'number') ? cart.total_price : 0;
        return (t > 0 && t < CART_FREE_SHIPPING_THRESHOLD_CENTS) ? 895 : 0;
      }
      function renderFreeShipping(cart) {
        var box = document.getElementById('cart-free-shipping');
        if (!box) return;
        if (!cart || !cart.item_count) {
          box.hidden = true;
          return;
        }
        var moneyFormat = window.theme.settings.showPriceWithCurrency
          ? window.theme.settings.moneyFormatWithCurrency
          : window.theme.settings.moneyFormat;
        var subtotal = (typeof cart.total_price === 'number') ? cart.total_price : 0;
        var remaining = CART_FREE_SHIPPING_THRESHOLD_CENTS - subtotal;
        var pct = Math.max(0, Math.min(100, (subtotal / CART_FREE_SHIPPING_THRESHOLD_CENTS) * 100));
        var label = box.querySelector('[data-cart-fsb-label]');
        var fill = box.querySelector('[data-cart-fsb-fill]');
        var leadHTML = ' <span class="cart-fsb__lead">Free shipping!</span>';
        if (remaining > 0) {
          if (label) {
            label.classList.remove('cart-fsb__label--unlocked');
            label.innerHTML = '<span class="cart-fsb__rest">Spend ' + Shopify.formatMoney(remaining, moneyFormat) + ' more to unlock</span>' + leadHTML;
          }
          if (fill) {
            fill.classList.remove('cart-fsb__fill--unlocked');
            fill.style.width = pct + '%';
          }
        } else {
          if (label) {
            label.classList.add('cart-fsb__label--unlocked');
            label.innerHTML = '<span class="cart-fsb__rest">You’ve unlocked</span>' + leadHTML;
          }
          if (fill) {
            fill.classList.add('cart-fsb__fill--unlocked');
            fill.style.width = '100%';
          }
        }
        box.hidden = false;
      }

      /* V3 — Totals reconcile. Subtotal = full (pre-discount) price so it
         matches the struck per-line prices; the big total (#cart-est-amt) and the
         breakdown "Your total" (#cart-net-amt) = net item price PLUS the flat
         shipping estimate (neswShipCents). The struck full price and the "You save"
         line stay items-only (they must not include shipping). renderDiscount
         handles the savings line. Kept the name `renderShipping` since several
         call sites invoke it. */
      function renderShipping(cart) {
        if (!cart) return;
        var moneyFormat = window.theme.settings.showPriceWithCurrency
          ? window.theme.settings.moneyFormatWithCurrency
          : window.theme.settings.moneyFormat;
        var orig = (typeof cart.original_total_price === 'number') ? cart.original_total_price
                 : (typeof cart.total_price === 'number' ? cart.total_price : 0);
        var net = (typeof cart.total_price === 'number') ? cart.total_price : orig;
        var gap = Math.max(0, orig - net);
        var shipCents = neswShipCents(cart);
        var estTotal = net + shipCents;
        /* "Total first" layout: #cart-est-amt = the big total (net + shipping),
           #cart-subtotal-amt = the struck full price beside it (hidden when nothing
           is discounted). */
        var subEl = document.getElementById('cart-subtotal-amt');
        if (subEl) { subEl.textContent = Shopify.formatMoney(orig, moneyFormat); subEl.hidden = gap <= 0; }
        var estEl = document.getElementById('cart-est-amt');
        if (estEl) estEl.textContent = Shopify.formatMoney(estTotal, moneyFormat);
        var fullEl = document.getElementById('cart-full-amt');
        if (fullEl) fullEl.textContent = Shopify.formatMoney(orig, moneyFormat);
        var netEl = document.getElementById('cart-net-amt');
        if (netEl) netEl.textContent = Shopify.formatMoney(estTotal, moneyFormat);
        /* V3 — Shipping line (subrow) + breakdown shipping row. Under threshold:
           "Includes $8.95 shipping"; at/over: "Free shipping included" / "Free". */
        var shipLine = document.getElementById('cart-shipline');
        if (shipLine) {
          if (shipCents > 0) {
            shipLine.classList.remove('cart-shipline--free');
            shipLine.innerHTML = 'Includes <span class="cart-shipline__amt">' + Shopify.formatMoney(shipCents, moneyFormat) + '</span> shipping';
          } else {
            shipLine.classList.add('cart-shipline--free');
            shipLine.textContent = 'Free shipping included';
          }
        }
        var breakShipAmt = document.getElementById('cart-break-ship-amt');
        if (breakShipAmt) {
          if (shipCents > 0) {
            breakShipAmt.classList.remove('cart-break__ship-amt--free');
            breakShipAmt.textContent = Shopify.formatMoney(shipCents, moneyFormat);
          } else {
            breakShipAmt.classList.add('cart-break__ship-amt--free');
            breakShipAmt.textContent = 'Free';
          }
        }
        /* 🔴 Un-hide the totals rows once the cart has items. The SSR stamps
           `hidden` on them when the cart is empty at page load; an AJAX add
           (e.g. adding a bundle from a PDP whose cart started empty) fills in
           the amounts here but the rows stayed display:none — the "no total"
           bug. Toggle from the authoritative item_count so the rows always
           match the cart state. Save line + breakdown also need savings > 0. */
        var hasItems = ((typeof cart.item_count === 'number') ? cart.item_count
                        : (cart.items ? cart.items.length : 0)) > 0;
        var totalRow = document.getElementById('cart-total');
        var subRow = document.getElementById('cart-subrow');
        if (totalRow) totalRow.hidden = !hasItems;
        if (subRow) subRow.hidden = !hasItems;
        var saveEl = document.getElementById('cart-saveline');
        if (saveEl) {
          saveEl.textContent = 'You save ' + Shopify.formatMoney(gap, moneyFormat);
          saveEl.hidden = !(hasItems && gap > 0);
        }
        var breakEl = document.getElementById('cart-break');
        if (breakEl) breakEl.hidden = !(hasItems && gap > 0);
      }

      /* V2 — Split total savings into Summer Sale + Bundle & Save. Shopify
         function discounts don't expose per-line allocations in cart.js, so
         derive per line: Summer = min(NESW_SALE_CENTS × qty, line discount);
         Bundle = the remainder (the bundle stacks on top of the sale). Returns
         { groups, order } with Summer Sale first, Bundle & Save on top. */
      function neswCollectDiscounts(cart) {
        var groups = {}, order = [];
        function add(label, amt) {
          amt = Number(amt) || 0;
          if (amt <= 0) return;
          if (!(label in groups)) { groups[label] = 0; order.push(label); }
          groups[label] += amt;
        }
        var SC = window.NESW_SALE_CENTS || {};
        var summer = 0, bundle = 0;
        if (cart && Array.isArray(cart.items)) {
          cart.items.forEach(function (it) {
            var qty = it.quantity || 1;
            var orig = (typeof it.original_line_price === 'number') ? it.original_line_price : ((it.original_price || 0) * qty);
            var fin = (typeof it.final_line_price === 'number') ? it.final_line_price : (((typeof it.final_price === 'number' ? it.final_price : it.price) || 0) * qty);
            var td = orig - fin;
            if (td <= 0) return;
            var scLine = (SC[it.product_id] || 0) * qty;
            var lineSummer = scLine > 0 ? Math.min(scLine, td) : 0;
            summer += lineSummer;
            bundle += (td - lineSummer);
          });
        }
        add('Summer Sale', summer);
        add('Bundle & Save', bundle);
        /* Order-level codes (NESW10 etc.) are allocated "across" the cart, not
           onto the lines — final_line_price excludes them while total_price
           includes them. One row per application keeps the visible rows summing
           to the real drop between Subtotal and Estimated total. */
        if (cart && Array.isArray(cart.cart_level_discount_applications)) {
          cart.cart_level_discount_applications.forEach(function (app) {
            if (app) add((app.type === 'discount_code' ? 'Code ' : '') + (app.title || 'Discount'), app.total_allocated_amount);
          });
        }
        return { groups: groups, order: order };
      }

      function renderDiscount(cart) {
        if (!cartDiscountEl) return;
        var moneyFormat = window.theme.settings.showPriceWithCurrency
          ? window.theme.settings.moneyFormatWithCurrency
          : window.theme.settings.moneyFormat;
        var res = neswCollectDiscounts(cart);
        if (res.order.length > 0) {
          cartDiscountEl.innerHTML = res.order.map(function (label) {
            return '<div class="cart-discount__row">' +
              '<span class="cart-discount__label">' + escapeHtml(label) + '</span>' +
              '<span class="cart-discount__amount">−' + Shopify.formatMoney(res.groups[label], moneyFormat) + '</span>' +
            '</div>';
          }).join('');
          cartDiscountEl.hidden = false;
          return;
        }
        /* Fallback for the optimistic-remove synthetic cart (no allocation
           data): a single savings row from the price gap, reconciled by the
           next authoritative /cart.js render. */
        var gap = 0;
        if (cart && typeof cart.original_total_price === 'number' && typeof cart.total_price === 'number') {
          gap = cart.original_total_price - cart.total_price;
        }
        if (gap > 0) {
          cartDiscountEl.innerHTML = '<div class="cart-discount__row">' +
            '<span class="cart-discount__label">Discount</span>' +
            '<span class="cart-discount__amount">−' + Shopify.formatMoney(gap, moneyFormat) + '</span>' +
          '</div>';
          cartDiscountEl.hidden = false;
        } else {
          cartDiscountEl.hidden = true;
          cartDiscountEl.innerHTML = '';
        }
      }

      /* V2 — Optimistic totals on remove. Sums the remaining rows'
         `data-line-price` (each line's final price in cents) and paints
         the total + free-shipping bar IMMEDIATELY on the × tap, so the
         price moves in lockstep with the row collapse instead of waiting
         for the /cart/change.js round-trip. The authoritative change.js
         response reconciles right after (it overwrites these same
         elements), so a cart-level code that re-tiers the discount still
         lands correct within ~one network hop. Excludes the row being
         removed by variant id. Returns the remaining line count so the
         caller can skip painting when the cart is about to be empty
         (the change.js empty-cart branch handles that case). */
      function optimisticRemoveTotals(removedVariantId) {
        try {
          var finalSum = 0, origSum = 0, remaining = 0;
          document.querySelectorAll('#cart-items .cart-item').forEach(function (row) {
            if (row.dataset.variantId === String(removedVariantId)) return;
            remaining++;
            var lp = parseInt(row.dataset.linePrice, 10);
            if (!isNaN(lp)) finalSum += lp;
            var op = parseInt(row.dataset.originalLinePrice, 10);
            origSum += isNaN(op) ? (isNaN(lp) ? 0 : lp) : op;
          });
          if (remaining === 0) return 0; // let the empty-cart path take over
          /* Optimistic synthetic cart: Subtotal = original sum, Estimated
             total = net (final) sum, Discount = the gap. Reconciled by the
             change.js response immediately after. */
          var synthetic = {
            item_count: remaining,
            items_subtotal_price: finalSum,
            total_price: finalSum,
            original_total_price: origSum
          };
          renderFreeShipping(synthetic);
          renderShipping(synthetic);   // sets Subtotal (orig) + Estimated total (net)
          renderDiscount(synthetic);   // sets the savings line
          return remaining;
        } catch (_) { return -1; }
      }
    
      // Only proceed if we have the necessary elements
      if (!cartDrawer) {
        return;
      }
    
      function closeGlobalMenu() {
        const body = document.body;
        if (body.classList.contains('pushy-open-left')) {
          body.classList.remove('pushy-open-left');
        } else if (body.classList.contains('pushy-open-right')) {
          body.classList.remove('pushy-open-right');
        }
      }
    
      /* V2 — Track SSR freshness. The cart items + total are server-
         rendered on every page load, so they reflect the cart state
         at the moment that page was requested. Any cart mutation
         (add / remove / qty change) since then makes the SSR stale.
         We dispatch `cart:change` from every mutation site, so
         listening for it tells us when to re-fetch.

         Why this matters for the open glitch: previously, openCartDrawer
         ALWAYS called updateCart(), which triggered a /cart.js fetch
         and then replaced #cart-items.innerHTML — even when the SSR'd
         DOM was already correct. On mobile, that DOM teardown +
         re-create during the drawer's 300 ms slide-in animation
         showed up as a brief layout reflow / image flicker. Jay
         called it a "CLS glitch".

         New behavior: trust SSR on first open after a clean page
         load. Only re-fetch when the cart has actually changed.
         Cross-tab updates are an edge case the next open after a
         change will catch. */
      var __cartSSRStale = false;
      /* V2 — Track the last-known cart item count so the drawer never flashes
         a loading skeleton for an EMPTY cart (Jay: "shows a skeleton loader
         when it's empty even though there's no products"). Seeded from SSR and
         updated on every cart mutation broadcast + fetch. */
      var __cdEl = document.getElementById('cart-drawer');
      var __knownItemCount = __cdEl ? (parseInt(__cdEl.getAttribute('data-item-count'), 10) || 0) : 0;
      document.addEventListener('cart:change', function (e) {
        __cartSSRStale = true;
        if (e && e.detail && typeof e.detail.item_count === 'number') {
          __knownItemCount = e.detail.item_count;
        }
      });

      /* V3 — An add-to-cart that happens OUTSIDE this theme's own scripts
         (the Ignis pack builder block; any Prestige-style surface) announces
         itself with `cart:refresh` on document, carrying the fresh /cart.js
         read as `detail.cart` when it has one. Fold that into the theme's own
         `cart:change` and open the drawer, so an add from an app block gets
         the same ending as one from the PDP form. Without this the pack
         builder's "stay on the page" ending was silent on this store: the add
         succeeded and nothing on the page moved (2026-09-10). A `cart:refresh`
         with no cart is ignored: nothing here guesses at a cart. */
      document.addEventListener('cart:refresh', function (e) {
        var cart = e && e.detail && e.detail.cart;
        if (!cart || typeof cart.item_count !== 'number') return;
        document.dispatchEvent(new CustomEvent('cart:change', { detail: cart }));
        openCartDrawer();
      });

      function openCartDrawer() {
        cartDrawer.classList.add('open');
        cartDrawer.classList.remove('header-collapsed'); // always open with header showing
        var __cdc = document.querySelector('.cart-drawer-content');
        if (__cdc) __cdc.scrollTop = 0;
        cartDrawer.classList.remove('fsb-collapsed'); // always open with the FSB card showing
        cartDrawerOverlay.classList.add('active');
        document.body.classList.add('nesw-cart-open'); // for hiding overlays
        document.body.style.overflow = 'hidden'; // Prevent scrolling
        closeGlobalMenu();
        initFomoTimer();
        /* If SSR'd items match the current cart state, skip the fetch
           + innerHTML replace entirely — that's what was causing the
           open-time glitch. Repaint nothing; the drawer just slides
           in over the existing DOM. */
        if (!__cartSSRStale && cartItems.children.length > 0) return;
        /* Otherwise: skeleton only when empty, then fetch + render. 🔴 Use a
           FRESH /cart.js (no cache): we only reach here when the SSR is stale
           (a mutation happened) or the list is empty. The prefetch cache can
           be from BEFORE that mutation, which showed the cart one step behind
           — items "added but not showing" (Jay). Correctness > the few ms the
           cache saved. */
        /* Only skeleton when we actually expect items to load. On a truly
           empty cart (__knownItemCount === 0) the SSR empty-state is already
           in the DOM, so skip the skeleton and avoid the empty-cart flash. */
        if (cartItems.children.length === 0 && __knownItemCount > 0) showCartSkeleton();
        updateCart();
        /* Catch up the upsell/low-stock refresh that the cart:change listener
           (below, __refreshCartDrawerUpsell) skipped while the drawer was
           closed — hoisted function declaration, so calling it here ahead of
           its textual definition is safe. */
        if (__cartSSRStale) __refreshCartDrawerUpsell();
        __cartSSRStale = false;
      }
    
      /* V2 — Also toggle the upsell wrap during loading. Without this,
         the "Pair It With" row paints immediately (it's in the SSR'd
         DOM with images already loaded) while the cart items wait
         for `/cart.js` to resolve — which Jay called out as the
         drawer opening with the upsell visible a full second before
         line items appear. Tying the upsell visibility to the skeleton
         state hides both surfaces together and reveals them together,
         so the drawer reads as "everything painted at once". */
      var __cartUpsellWrap = document.querySelector('.cart-drawer-upsell-wrap');
      function showCartSkeleton() {
        cartItems.style.display = 'none';
        cartSkeleton.style.display = 'block';
        if (__cartUpsellWrap) __cartUpsellWrap.style.visibility = 'hidden';
      }

      function hideCartSkeleton() {
        cartItems.style.display = 'block';
        cartSkeleton.style.display = 'none';
        if (__cartUpsellWrap) __cartUpsellWrap.style.visibility = '';
      }
    
      function closeCartDrawer() {
        cartDrawer.classList.remove('open');
        cartDrawerOverlay.classList.remove('active');
        document.body.classList.remove('nesw-cart-open');
        document.body.style.overflow = ''; // Re-enable scrolling
      }

      /* V2 — Collapse the CART header on scroll-down, reveal on
         scroll-up (same gesture as the main store's top bar). Frees the
         full drawer height for products + upsell while the customer is
         browsing the list. Direction-based with a small threshold so a
         tiny jitter near the top doesn't flicker the header. */
      /* V2 — Header-collapse-on-scroll DISABLED. Animating the header's
         max-height while the customer scrolls reflowed the scroll container
         mid-gesture, which on iOS read as the scroll "jerking" unevenly
         toward the bottom (Jay). The header is already compact, so it just
         stays put now — no layout change during scroll. */
      (function initCartHeaderCollapse() {
        if (cartDrawer) cartDrawer.classList.remove('header-collapsed');
      })();
    
      /* V2 — Cart prefetch cache. When the customer hovers / focuses /
         touchstarts a cart button, we warm the /cart.js response in
         the background and store it here. The next `updateCart()`
         consumes the cache (once, then nulls it) so the drawer skips
         the visible fetch delay entirely. 5-second freshness window
         keeps the cache from going stale across long hovers. */
      var __cartCache = null;
      var __cartCacheTime = 0;
      var __cartInflight = null;
      function __cartFreshMs() { return Date.now() - __cartCacheTime; }
      /* Expose the warm-cart snapshot to OTHER scripts on the page that need
         a recent read without paying for another /cart.js round trip.
         Currently consumed only by nesw-cart-limit-guard.liquid's add-to-cart
         cap check — that snippet runs from <head>, before this file, so it
         cannot see __cartCache directly.
         Single-use by design, same as the updateCart(true) consumption below:
         the FIRST caller in a burst gets the snapshot and it is immediately
         nulled, so a second add in the same burst can never reuse a count
         the first add's own delta has already made stale — it falls through
         to a real fetch instead. Freshness window matches __cartFreshMs()
         (5s) everywhere else in this file. */
      window.__neswCartCache = function () {
        if (!__cartCache || __cartFreshMs() >= 5000) return null;
        var snapshot = __cartCache;
        __cartCache = null;
        __cartCacheTime = 0;
        return { cart: snapshot };
      };
      function __warmCart() {
        if (__cartFreshMs() < 5000) return;       // recent fetch still fresh
        if (__cartInflight) return;               // already fetching
        __cartInflight = fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            __cartCache = cart;
            __cartCacheTime = Date.now();
            return cart;
          })
          .catch(function () { return null; })
          .then(function (cart) { __cartInflight = null; return cart; });
      }
      /* Bind once, including any cart buttons that get rendered after
         load (e.g. floating cart on scroll). Re-runs cheap selector
         queries; idempotent via the `__neswPrefetchBound` flag. */
      function __bindCartPrefetch() {
        var sels = '.cart-button-rectangle, [data-nesw-top-cart], .nesw-topnav__btn--cart, .nesw-floating-cart, .nesw-floating-cart__btn';
        document.querySelectorAll(sels).forEach(function (el) {
          if (el.__neswPrefetchBound) return;
          el.__neswPrefetchBound = true;
          el.addEventListener('mouseenter', __warmCart, { passive: true });
          el.addEventListener('touchstart', __warmCart, { passive: true });
          el.addEventListener('focus', __warmCart, { passive: true });
        });
      }
      __bindCartPrefetch();
      window.addEventListener('load', __bindCartPrefetch);
      document.addEventListener('cart:change', __bindCartPrefetch);

      /* V2 — Re-render the "Pair It With" upsell on every cart change so products
         the customer just added drop OUT of the recommendations. The upsell is
         server-rendered and already excludes in-cart items, but it was only built
         once at page load, so added items lingered until a full reload. Pull a
         fresh cart-drawer section (renders with the current cart) and swap just the
         upsell container. Delegated click handlers keep working on the new DOM.
         Debounced so rapid qty changes don't spam the Section Rendering API. */
      /* 🔴 Gated on visibility. Measured up to 65,738 bytes / 310ms per hit,
         firing on EVERY cart:change regardless of whether the drawer was even
         open — the homepage size-add path alone cost 131KB for one add, none
         of it visible to the shopper (w3-3-inp.json). `.open` is added
         synchronously at the very top of openCartDrawer, before any async
         work, so checking it also covers "opening", not just "already open".
         While closed, skip the network call outright: __cartSSRStale is
         already set true by the cart:change listener above on every
         mutation, and openCartDrawer's own stale check (further up this
         file) calls __refreshCartDrawerUpsell() itself the next time the
         drawer opens — so nothing here is permanently lost, only deferred to
         when it's actually visible. */
      /* All refresh triggers (open-with-stale, and both cart:change
         dispatches an add produces) funnel through ONE trailing debounce +
         single-flight guard — the Fable wave-3 review measured the previous
         shape reliably double-fetching ~65KB per add-that-opens. */
      var __upsellInFlight = false, __upsellQueued = false;
      function __refreshCartDrawerUpsell() {
        clearTimeout(__upsellRefreshT);
        __upsellRefreshT = setTimeout(__runUpsellRefresh, 400);
      }
      function __runUpsellRefresh() {
        if (__upsellInFlight) { __upsellQueued = true; return; }
        __upsellInFlight = true;
        fetch('/?sections=cart-drawer')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var html = data && data['cart-drawer'];
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-cart-upsell]');
            var current = document.querySelector('[data-cart-upsell]');
            if (fresh && current) current.replaceWith(fresh);
            if (window.__neswUpsellNavSync) window.__neswUpsellNavSync();
            /* The fetched fragment is SSR HTML with CORRECT low-stock badges.
               Refresh the server-truth cache from it, then patch the live
               rows so a just-added low-stock item gains its badge one beat
               after the add, and existing rows keep theirs. */
            __neswHarvestLowStock(doc);
            __neswPatchLowStock();
            __upsellInFlight = false;
            if (__upsellQueued) { __upsellQueued = false; __refreshCartDrawerUpsell(); }
          })
          .catch(function () {
            __upsellInFlight = false;
            if (__upsellQueued) { __upsellQueued = false; __refreshCartDrawerUpsell(); }
          });
      }
      var __upsellRefreshT;

      /* ===== Pair It With: desktop arrows =====
         A 4px scrollbar is not a control anyone can aim at with a mouse, and on
         desktop there is no swipe to fall back on, so the row read as static
         (Jay, 2026-09-10). Touch keeps the swipe and keeps the bar; the buttons
         are pointer:fine only. Delegated, because the whole row is replaced by
         the refresh above, which would drop any listener bound to the old node. */
      function __neswUpsellNavSync() {
        document.querySelectorAll('.cd-upsell-rail').forEach(function (rail) {
          var sc = rail.querySelector('.related-products-scroll-container');
          if (!sc) return;
          if (!sc.__neswNavBound) {
            sc.__neswNavBound = true;
            sc.addEventListener('scroll', __neswUpsellNavSync, { passive: true });
          }
          var max = sc.scrollWidth - sc.clientWidth;
          var prev = rail.querySelector('[data-upsell-nav="-1"]');
          var next = rail.querySelector('[data-upsell-nav="1"]');
          /* 🔴 An arrow at its limit is DIMMED, never removed. Hiding it pulled the
             target out from under a cursor that was already there, and the very
             next click landed on the product card behind it and navigated the
             shopper out of the cart. That is a funnel leak, not a cosmetic bug
             (Jay, 2026-09-10). The button stays in place and stays hit-testable,
             so a click at the end of the row costs nothing instead of costing the
             session. The handler below no-ops on `is-off`.

             4px of slack: browsers land a smooth scroll a sub-pixel short, so an
             exact comparison would leave the end arrow live forever. */
          var atStart = sc.scrollLeft <= 4;
          var atEnd = sc.scrollLeft >= max - 4;
          /* Nothing to scroll at all (three cards, no overflow): no arrows, since
             two permanently dead buttons are just clutter. */
          var noOverflow = max <= 4;
          if (prev) {
            prev.hidden = noOverflow;
            prev.classList.toggle('is-off', atStart);
            prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
          }
          if (next) {
            next.hidden = noOverflow;
            next.classList.toggle('is-off', atEnd);
            next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
          }
        });
      }
      window.__neswUpsellNavSync = __neswUpsellNavSync;

      document.addEventListener('click', function (e) {
        var nav = e.target && e.target.closest && e.target.closest('[data-upsell-nav]');
        if (!nav) return;
        /* Swallow it either way. The point of keeping a spent arrow on screen is
           that the click stops here rather than reaching the card behind it. */
        e.preventDefault();
        e.stopPropagation();
        if (nav.classList.contains('is-off')) return;
        var rail = nav.closest('.cd-upsell-rail');
        var sc = rail && rail.querySelector('.related-products-scroll-container');
        if (!sc) return;
        var card = sc.querySelector('li');
        var step = (card ? card.getBoundingClientRect().width : 150) + 12;
        sc.scrollBy({ left: step * Number(nav.getAttribute('data-upsell-nav') || 1), behavior: 'smooth' });
      });

      __neswUpsellNavSync();
      window.addEventListener('load', __neswUpsellNavSync);
      document.addEventListener('cart:change', function () { setTimeout(__neswUpsellNavSync, 60); });

      document.addEventListener('cart:change', function () {
        if (!cartDrawer.classList.contains('open')) return; // invisible now — caught on next open instead
        __refreshCartDrawerUpsell();
      });

      function updateCart(allowCache, presetCart) {
        /* V2 — Default to a FRESH /cart.js fetch. The prefetch cache is
           only safe for the drawer-OPEN paint (warmed by a hover/touch a
           moment earlier); after a mutation (add from "Pair It With", qty
           change, remove) it can be stale and would re-render the cart
           WITHOUT the item just added — the "didn't show til refresh, only
           some products" bug (it only bit when the cache happened to be
           warm at add time). So only the open path opts into the cache via
           `updateCart(true)`; every mutation caller passes no arg → fresh.
           Any non-cache refresh also clears the warm cache so a follow-up
           open can't paint stale state.

           `presetCart` — a cart object the CALLER already fetched (only the
           header-badge-sync wrapper below passes one, so it doesn't have to
           fetch /cart.js, hand off to this function, and have THIS function
           fetch /cart.js again for the same data — measured as two full
           round trips per updateCart() call, w3-3-inp.json). Takes priority
           over allowCache/the warm cache: by construction it is at least as
           fresh as either, and every existing caller still passes nothing,
           so this branch is additive, not a behavior change for them. */
        var useCache = !presetCart && allowCache && __cartCache && __cartFreshMs() < 5000;
        var p;
        if (presetCart) {
          p = Promise.resolve(presetCart);
          __cartCache = null;
          __cartCacheTime = 0;
        } else if (useCache) {
          p = Promise.resolve(__cartCache);
          __cartCache = null;
          __cartCacheTime = 0;
        } else {
          __cartCache = null;
          __cartCacheTime = 0;
          p = fetch('/cart.js').then(function (r) { return r.json(); });
        }
        p
          .then(cart => {
            const emptyCartMessage = document.getElementById('empty-cart-message');
            const cartDrawerFooter = document.getElementById('cart-drawer-footer');
            if (cart && typeof cart.item_count === 'number') __knownItemCount = cart.item_count;

            if (cart.item_count === 0) {
              cartItems.innerHTML = ''; // Clear the cart items
              cartItems.style.display = 'none';
              emptyCartMessage.style.display = 'block';
              cartDrawerFooter.style.display = 'none'; // Hide footer
              renderFreeShipping(cart); // empty cart → hide the free-shipping card (don't leave stale "spend $X more")
              var __sa2 = document.getElementById('cart-subtotal-amt');
              if (__sa2) __sa2.textContent = Shopify.formatMoney(cart.total_price,
                window.theme.settings.showPriceWithCurrency ? window.theme.settings.moneyFormatWithCurrency : window.theme.settings.moneyFormat
              );
            } else {
              cartItems.style.display = 'block';
              emptyCartMessage.style.display = 'none';
              cartDrawerFooter.style.display = 'block'; // Show footer

              /* Same compare-at bridge as reconcileCartInPlace, because this is
                 the OTHER path that can build rows — it runs when the drawer
                 opens on items added during this session, which is exactly the
                 case the server-rendered seed cannot cover. Rows below paint
                 with the plain price; the struck compare-at arrives when the
                 lookup lands. */
              (function () {
                var __cmpFmt = window.theme.settings.showPriceWithCurrency
                  ? window.theme.settings.moneyFormatWithCurrency : window.theme.settings.moneyFormat;
                ensureCompareAt(cart.items).then(function (learned) {
                  if (learned) neswRepriceRows(cart, __cmpFmt);
                });
              })();

              cartItems.innerHTML = cart.items.map(item => `
                <div class="cart-item${(item.properties && item.properties._bundle_id) ? ' cart-item--bundle cart-item--bundle-' + escapeHtml(item.properties._bundle_role || 'core') : ''}" data-variant-id="${item.variant_id}" data-line-key="${escapeHtml(item.key || '')}"${(item.properties && item.properties._bundle_id) ? ' data-bundle-id="' + escapeHtml(item.properties._bundle_id) + '" data-bundle-role="' + escapeHtml(item.properties._bundle_role || 'core') + '" data-bundle-kind="' + escapeHtml(item.properties._bundle_kind || '') + '"' : ''} data-line-price="${item.final_line_price}" data-original-line-price="${item.original_line_price}" data-qty="${item.quantity}">
                  <a href="${escapeHtml(item.url)}">
                    <img
                      src="${escapeHtml(item.image.replace(/(\.[^.]*)$/, '_360x$1'))}"
                      srcset="${escapeHtml(item.image.replace(/(\.[^.]*)$/, '_180x$1'))} 180w, ${escapeHtml(item.image.replace(/(\.[^.]*)$/, '_240x$1'))} 240w, ${escapeHtml(item.image.replace(/(\.[^.]*)$/, '_360x$1'))} 360w, ${escapeHtml(item.image.replace(/(\.[^.]*)$/, '_480x$1'))} 480w"
                      sizes="(min-width: 769px) 128px, 60px"
                      alt="${escapeHtml(item.title)}"
                      loading="lazy"
                      decoding="async"
                    >
                  </a>
                  <div class="cart-item-details">
                    <div class="cart-item-title">${escapeHtml(item.product_title || item.title)}</div>
                    ${(function () {
                      /* Pull every variant option in the order the
                         product defined them so the line always shows
                         the full chip (e.g. "STONE BLUE / M") instead
                         of guessing at "color" / "size" by name. Some
                         products use option names like "Colour" or
                         "Style" that the old lowercase match dropped
                         entirely — leaving both halves missing. */
                      var label = '';
                      if (Array.isArray(item.options_with_values) && item.options_with_values.length) {
                        label = item.options_with_values
                          .map(function (o) { return o && o.value ? o.value : ''; })
                          .filter(Boolean)
                          .join(' / ');
                      }
                      if (!label && Array.isArray(item.variant_options)) {
                        label = item.variant_options.filter(Boolean).join(' / ');
                      }
                      if (!label && item.variant_title && item.variant_title !== 'Default Title') {
                        label = item.variant_title;
                      }
                      return label
                        ? '<div class="cart-item-variant">' + escapeHtml(label) + '</div>'
                        : '';
                    })()}
                    ${(function () {
                      /* 🔴 Line-item properties, mirroring the SSR block in
                         sections/cart-drawer.liquid. This template drew only the
                         `_bundle_*` structure and none of the line's VISIBLE
                         properties, so a custom pack added from the Ignis pack
                         builder appeared in the drawer as a bundle with no items:
                         the shopper got no confirmation of the picks they had just
                         made. The /cart page and a reloaded drawer were right,
                         because both are server-rendered; only this JS rebuild,
                         the path that runs immediately after an add, was wrong.

                         Same rule as the Liquid and the cart page: every property
                         whose key does not begin with `_` and whose value is not
                         empty. The underscore prefix is Shopify's convention for
                         machine data, and the bundle ids this row reads above are
                         exactly that, so they stay hidden.

                         Same markup as the Liquid too, not merely similar: one
                         `<ul class="cart-item-props">` of `<li>` with the key in
                         `.cart-item-prop-k`. The two renderers style off the same
                         rules in nesw-cart-drawer.css, so a shopper cannot tell
                         which one drew the row. */
                      var props = item.properties;
                      if (!props || typeof props !== 'object') return '';
                      var rows = '';
                      Object.keys(props).forEach(function (k) {
                        if (!k || String(k).charAt(0) === '_') return;
                        var v = props[k];
                        if (v === null || v === undefined || String(v) === '') return;
                        rows += '<li><span class="cart-item-prop-k">' + escapeHtml(String(k)) +
                                ':</span> ' + escapeHtml(String(v)) + '</li>';
                      });
                      return rows ? '<ul class="cart-item-props">' + rows + '</ul>' : '';
                    })()}
                    ${(function () {
                      /* V2 — Discount-aware unit price (mirrors SSR). Uses
                         Shopify's real final_price (after Summer Sale + Bundle
                         & Save line discounts): struck original on top, red
                         discounted below, plus a tag naming each discount so a
                         bundled item reads clearly as a bundle. */
                      var fmt = window.theme.settings.showPriceWithCurrency ? window.theme.settings.moneyFormatWithCurrency : window.theme.settings.moneyFormat;
                      var orig = (typeof item.original_price === 'number' ? item.original_price : item.price);
                      var fin = (typeof item.final_price === 'number' ? item.final_price : orig);
                      var priceHtml = '<div class="cart-item-price">' +
                        neswPriceHtml(orig, fin, item.variant_id, fmt) + '</div>';
                      var scU = (window.NESW_SALE_CENTS || {})[item.product_id] || 0;
                      var tdU = orig - fin;
                      var summerU = (scU > 0 && tdU > 0) ? Math.min(scU, tdU) : 0;
                      var bundleU = tdU - summerU;
                      var hasSummer = summerU > 0, hasBundle = bundleU > 0;
                      var tags = '';
                      if (hasSummer || hasBundle) {
                        tags = '<div class="cart-item-tags">' +
                          (hasSummer ? '<span class="cart-item-tag cart-item-tag--summer">Summer Sale</span>' : '') +
                          (hasBundle ? '<span class="cart-item-tag cart-item-tag--bundle">Bundle &amp; Save</span>' : '') +
                        '</div>';
                      }
                      return priceHtml + tags;
                    })()}
                    ${(function () {
                      /* Bundle caption — mirrors SSR. Only the optional add-on
                         gets a caption (it can be removed on its own); core lines
                         already read as a bundle via the "Bundle & Save" tag. */
                      if (!(item.properties && item.properties._bundle_id)) return '';
                      if (item.properties._bundle_kind === 'pair') {
                        return '<div class="cart-item-bundlenote">Bundled pair &middot; Remove one to unbundle</div>';
                      }
                      if (item.properties._bundle_role !== 'addon') return '';
                      return '<div class="cart-item-bundlenote">Add-on &middot; Removable</div>';
                    })()}
                    ${(function () {
                      /* V2 — Low-stock badge replayed from the server-truth
                         cache (`__neswLowStockHTML`), seeded from SSR rows and
                         refreshed by the `/?sections=cart-drawer` re-fetch.
                         `/cart.js` never returns `variant_inventory_quantity`,
                         so we cannot compute it here — the cache is the only
                         source of truth. Non-empty string = the badge wrapper
                         HTML; '' or undefined = no badge. try/catch so a bad
                         cache entry can never break the .map chain. */
                      try {
                        var cached = (window.__neswLowStockHTML || {})[item.variant_id];
                        return (typeof cached === 'string' && cached) ? cached : '';
                      } catch (_) { return ''; }
                    })()}
                  </div>
                  <div class="cart-item-quantity">
                    ${(item.properties && item.properties._bundle_id && item.properties._bundle_kind !== 'pair')
                      ? '<span class="cart-item-qtylabel" aria-label="Quantity ' + item.quantity + '">Qty ' + item.quantity + '</span>'
                      : '<input type="number" class="quantity-input" value="' + item.quantity + '" min="0" max="9999">' +
                        '<div class="qty-stepper">' +
                          '<button type="button" class="qty-btn qty-minus" aria-label="Decrease quantity" tabindex="-1">&minus;</button>' +
                          '<button type="button" class="qty-btn qty-plus" aria-label="Increase quantity" tabindex="-1">+</button>' +
                        '</div>'}
                  </div>
                  <button type="button" class="cart-item-remove" aria-label="Remove ${escapeHtml(item.title)} from cart"><svg viewBox="0 0 14 14" aria-hidden="true"><path d="M3 3L11 11M11 3L3 11" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></button>
                </div>
              `).join('');
              var __sa3 = document.getElementById('cart-subtotal-amt');
              if (__sa3) __sa3.textContent = Shopify.formatMoney(cart.original_total_price || cart.total_price,
                window.theme.settings.showPriceWithCurrency ? window.theme.settings.moneyFormatWithCurrency : window.theme.settings.moneyFormat
              );
              addQuantityListeners();
              neswGroupBundles(); // re-wrap bundle rows after the full re-render
            }
            renderDiscount(cart);
            renderFreeShipping(cart);
            renderShipping(cart);

            hideCartSkeleton();

            /* V2 — When an item was just added from "Pair It With", jump the
               cart to the top so the shopper sees what they added (it renders
               at the top now, newest-first). Flag is set by the upsell add
               handler right before it calls updateCart(). */
            if (window.__neswScrollCartTopAfterUpdate) {
              window.__neswScrollCartTopAfterUpdate = false;
              var __cc = document.querySelector('.cart-drawer-content');
              if (__cc) __cc.scrollTop = 0;
              cartDrawer.classList.remove('fsb-collapsed');
            }

            // Add this check to toggle a class on the cart drawer
            if (cart.items.length > 3) {
              cartDrawer.classList.add('scrollable');
            } else {
              cartDrawer.classList.remove('scrollable');
            }
          })
          .catch(error => {
            console.error('Error:', error);
            hideCartSkeleton();
          });
      }
    
      function addQuantityListeners() {
        /* V2 — No-op. The X-remove + qty-input listeners now live as
           event-delegated handlers on the `#cart-items` container (set
           up once at DOMContentLoaded). Calling this after each render
           used to ALSO bind per-item handlers — which doubled every
           click, sending two `/cart/change.js` requests per X tap. The
           queue serialized them, but the second request (same variant
           id, same `quantity: 0`) returned a stale cart object that
           overwrote the first response's UI, sometimes resurrecting
           items mid-stream. */
      }
    
      function updateQuantity(variantId, newQuantity) {
        if (newQuantity < 0) return;

        const __esc = (window.CSS && CSS.escape) ? CSS.escape(variantId) : variantId;
        const cartItem = document.querySelector(`.cart-item[data-line-key="${__esc}"]`)
          || document.querySelector(`.cart-item[data-variant-id="${variantId}"]`);
        const quantityInput = cartItem.querySelector('.quantity-input');
        const originalQuantity = parseInt(quantityInput.value);

        quantityInput.value = newQuantity;

        /* Optimistic UI for the × delete (newQuantity === 0): collapse
           the row immediately so the shopper sees it disappear with no
           wait. The previous flow showed a `.cart-item-loading` spinner
           for the full duration of two sequential fetches (~1–2s). */
        const isDelete = newQuantity === 0;
        if (isDelete && cartItem) {
          cartItem.style.transition =
            'opacity 0.14s ease, transform 0.14s ease, max-height 0.2s ease, padding 0.2s ease, margin 0.2s ease, border-color 0.14s ease';
          cartItem.style.maxHeight = cartItem.offsetHeight + 'px';
          /* Force reflow so the height -> 0 transition animates from
             the explicit pixel height. */
          void cartItem.offsetHeight;
          cartItem.style.opacity = '0';
          cartItem.style.transform = 'translateX(16px)';
          cartItem.style.maxHeight = '0';
          cartItem.style.paddingTop = '0';
          cartItem.style.paddingBottom = '0';
          cartItem.style.marginTop = '0';
          cartItem.style.marginBottom = '0';
          cartItem.style.borderColor = 'transparent';
          setTimeout(function () { if (cartItem.parentNode) cartItem.remove(); }, 200);
          /* Paint the new total instantly; change.js reconciles below. */
          optimisticRemoveTotals(variantId);
        } else {
          cartItem.classList.add('cart-item-loading');
        }

        __cartOpsPending++;
        var __opSettled = false;
        cartChangeQueue = cartChangeQueue
        .catch(function () { /* swallow prior errors so the queue keeps moving */ })
        .then(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: newQuantity })
          });
        })
        .then(function (response) {
          /* Route 422/429/5xx into the catch (which restores the row / hides
             the skeleton) instead of parsing an error body as if it were a
             valid cart — a non-ok body has no item_count and would blank the
             badge. Mirrors the guard on the V2 /cart/update.js batch path. */
          if (!response.ok) throw new Error('cart change failed: ' + response.status);
          return response.json();
        })
        .then(cart => {
          /* Decrement first; only the final pending op reconciles totals
             (see __cartOpsPending note) so a spam-delete burst doesn't
             bounce the price through stale intermediate server values. */
          if (__cartOpsPending > 0) __cartOpsPending--;
          __opSettled = true;
          var __isLastOp = __cartOpsPending === 0;
          /* Keys re-drift on every mutation (bundle Function re-keys all
             lines) — refresh them from this settle too, so a removal queued
             while a qty change was in flight still POSTs current keys. The
             change.js totals are unreliable but its items/keys are fine. */
          if (typeof __refreshRowLineKeys === 'function') __refreshRowLineKeys(cart);
          /* Update header badges + dispatch cart:change directly from
             the change.js response so the badge updates instantly
             without an extra /cart.js fetch. */
          if (typeof paintCartBadges === 'function') {
            paintCartBadges(cart.item_count);
          } else {
            document.querySelectorAll('.cart-count').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          }
          document.dispatchEvent(new CustomEvent('cart:change', { detail: cart }));

          if (cart.item_count === 0) {
            cartItems.innerHTML = '';
            const emptyCartMessage = document.getElementById('empty-cart-message');
            const cartDrawerFooter = document.getElementById('cart-drawer-footer');
            if (emptyCartMessage) emptyCartMessage.style.display = 'block';
            if (cartDrawerFooter) cartDrawerFooter.style.display = 'none';
            if (typeof renderFreeShipping === 'function') renderFreeShipping(cart); // hide the free-shipping card on empty (was keeping the last "spend $X more")
          } else if (__isLastOp) {
            /* Only the final pending op reconciles totals, so a burst of
               deletes/changes doesn't flash stale intermediate values. */
            if (!isDelete) {
              /* For qty changes (not deletes) we still need the totals
                 line refreshed. updateCart re-fetches and re-renders. */
              updateCart();
            } else {
              /* Delete path: 🔴 do NOT trust the change.js `cart` totals —
                 Shopify's /cart/change.js mis-reports automatic-discount
                 totals (it left ~$8.95 shipping in the Estimated total and
                 shrank the discount: Hoodies −$10 → −$1.05, $78 → $86.95;
                 "reset on refresh" because SSR reads a FRESH cart). Re-fetch
                 the authoritative /cart.js, but update ONLY the totals — do
                 NOT innerHTML the item list (the removed row is already
                 animated out; re-rendering it reflows + reloads the images,
                 which is the "Pair It With" CLS shift Jay flagged). */
              fetch('/cart.js')
                .then(function (r) { return r.json(); })
                .then(function (fresh) {
                  if (typeof renderDiscount === 'function') renderDiscount(fresh);
                  if (typeof renderFreeShipping === 'function') renderFreeShipping(fresh);
                  if (typeof renderShipping === 'function') renderShipping(fresh);
                })
                .catch(function () {});
            }
          }
        })
        .catch(error => {
          if (!__opSettled && __cartOpsPending > 0) __cartOpsPending--;
          console.error('Error:', error);
          /* On failure, restore the row so the shopper isn't stranded
             with a phantom-deleted item. */
          quantityInput.value = originalQuantity;
          if (isDelete && cartItem && !cartItem.parentNode) {
            /* Item was already detached — full re-render is the
               simplest path back to truth. */
            updateCart();
          } else if (cartItem) {
            cartItem.classList.remove('cart-item-loading');
          }
        })
        .finally(() => {
          if (!isDelete && cartItem) {
            cartItem.classList.remove('cart-item-loading');
          }
        });
      }

      /* ─────────────────────────────────────────────────────────────────────
         V2 — Batched, glitch-free removal system.

         Every delete (× on a normal item, × on a bundle add-on, "Remove bundle",
         a stepper/qty edit down to 0) funnels through queueRowRemoval → a short
         debounce → ONE /cart/update.js keyed by LINE KEYS. So spam-deleting a
         handful of items fires a single request and they all vanish together
         (snappy, like the batched add), instead of a staggered 1-2-3-4.

         Line KEYS (never variant ids) mean a bundle removal drops exactly its
         own lines, never a same-variant item sitting outside the bundle.

         Reconcile is IN-PLACE (reconcileCartInPlace): it patches the remaining
         rows' prices/tags and drops the removed rows — it does NOT rebuild the
         whole list, so no image reload / reflow flash (the post-delete "glitch").

         🔴 2026-07-03 — rapid-multi-delete race fix (see
         CART-DRAWER-RAPID-DELETE-RACE-HANDOFF.md). Jay repro: spam-delete all
         items → list looked empty, discount line frozen stale, badge said 7,
         reopen showed all 7 back. Root causes closed here:
         (a) Line keys were captured at CLICK time, but the bundle discount
             Function RE-KEYS every line on every cart change — overlapping
             batches submitted stale keys that /cart/update.js silently
             no-ops. Keys are now resolved at POST time (inside the serialized
             queue, after the prior batch settled) and refreshed from EVERY
             settled response via __refreshRowLineKeys, not only inside the
             often-skipped last-op reconcile.
         (b) The discount block / footer were only ever touched inside the
             pending===0 reconcile, so mid-burst they froze at pre-burst
             values while every row had already animated out. The optimistic
             paint now hides them the moment the visible row count hits 0
             (the authoritative reconcile re-shows them if items remain).
         (c) Pending (queued/in-flight) removals are tracked as ROW ELEMENTS
             with a __neswRemovePending flag; reconcileCartInPlace matches
             still-existing cart lines to those rows instead of treating them
             as "missing" (which forced a full rebuild that resurrected rows
             mid-removal and orphaned their queued keys). */

      var __pendingRemoveRows = [];
      var __removeFlushTimer = null;

      /* Refresh every row's data-line-key from an authoritative cart payload.
         Runs on EVERY settled mutation (not just the last-op reconcile) so a
         queued removal batch never POSTs a key the bundle-discount Function
         already re-keyed away. Live rows consume fresh lines first (same
         variant-id + DOM-order semantics as reconcileCartInPlace); rows mid-
         removal take whatever lines remain for their variant, so a pending
         removal keeps tracking its real server line. */
      function __refreshRowLineKeys(cart) {
        if (!cart || !Array.isArray(cart.items)) return;
        var freshByVar = {};
        cart.items.forEach(function (it) {
          var v = String(it.variant_id);
          (freshByVar[v] = freshByVar[v] || []).push(it);
        });
        var live = [], removing = [];
        [].slice.call(cartItems.querySelectorAll('.cart-item')).forEach(function (r) {
          (r.getAttribute('data-removing') ? removing : live).push(r);
        });
        var consumed = {};
        live.concat(removing).forEach(function (r) {
          var v = String(r.dataset.variantId || '');
          var items = freshByVar[v] || [];
          var i = consumed[v] || 0;
          if (items[i]) { r.dataset.lineKey = items[i].key; consumed[v] = i + 1; }
        });
      }

      /* A queued removal row can be detached by a full rebuild (updateCart)
         that lands between queue time and POST time. The shopper still asked
         for that line to go — find its rebuilt twin so the flush can remove
         it: exact line-key match first, then same variant id + same bundle
         membership. Returns null if the line is already gone server-side. */
      function __relocateRowForRemoval(oldRow) {
        var k = oldRow.dataset.lineKey || '';
        var v = String(oldRow.dataset.variantId || '');
        var b = String(oldRow.dataset.bundleId || '');
        var rows = [].slice.call(cartItems.querySelectorAll('.cart-item:not([data-removing])'));
        var match = null;
        rows.some(function (r) {
          if (k && r.dataset.lineKey === k) { match = r; return true; }
          return false;
        });
        if (!match) {
          rows.some(function (r) {
            if (String(r.dataset.variantId || '') === v &&
                String(r.dataset.bundleId || '') === b) { match = r; return true; }
            return false;
          });
        }
        return match;
      }

      function __animateRowOut(row) {
        row.setAttribute('data-removing', '1');
        row.style.pointerEvents = 'none';
        row.style.transition =
          'opacity 0.14s ease, transform 0.14s ease, max-height 0.2s ease, padding 0.2s ease, margin 0.2s ease, border-color 0.14s ease';
        row.style.maxHeight = row.offsetHeight + 'px';
        void row.offsetHeight; // reflow so the height→0 transition animates
        row.style.opacity = '0';
        row.style.transform = 'translateX(16px)';
        row.style.maxHeight = '0';
        row.style.paddingTop = '0'; row.style.paddingBottom = '0';
        row.style.marginTop = '0'; row.style.marginBottom = '0';
        row.style.borderColor = 'transparent';
      }

      /* Optimistic totals painted straight from the rows still on screen, so the
         Subtotal/Estimated total move in lockstep with the collapse (no wait for
         the server). Discount rows are left as-is until the authoritative
         reconcile — avoids a flicker between the split lines and a synthetic one.
         EXCEPT when the visible row count hits 0: then a lingering discount /
         footer reads as "empty cart but still shows a 25% sale" (Jay's bug), so
         the whole money block hides immediately. If the server disagrees (items
         actually remain), the authoritative reconcile / updateCart re-shows it. */
      function __optimisticTotalsFromRemaining() {
        var origSum = 0, finSum = 0, count = 0;
        [].slice.call(cartItems.querySelectorAll('.cart-item')).forEach(function (row) {
          if (row.getAttribute('data-removing')) return;
          origSum += parseInt(row.dataset.originalLinePrice, 10) || 0;
          finSum += parseInt(row.dataset.linePrice, 10) || 0;
          count++;
        });
        var synthetic = {
          item_count: count, items: count ? [{}] : [],
          original_total_price: origSum, total_price: finSum, items_subtotal_price: finSum
        };
        renderShipping(synthetic);
        renderFreeShipping(synthetic);
        if (count === 0) {
          if (cartDiscountEl) { cartDiscountEl.hidden = true; cartDiscountEl.innerHTML = ''; }
          var __footer = document.getElementById('cart-drawer-footer');
          if (__footer) __footer.style.display = 'none';
          var __emptyMsg = document.getElementById('empty-cart-message');
          if (__emptyMsg) __emptyMsg.style.display = 'block';
        }
      }

      function __flushRemovals() {
        __removeFlushTimer = null;
        var queuedRows = __pendingRemoveRows;
        __pendingRemoveRows = [];
        if (!queuedRows.length) return;
        __cartOpsPending++;
        var settled = false;
        /* Grows with any relocated rows so the settle/error cleanup clears
           every __neswRemovePending flag this batch owns. */
        var batchRows = queuedRows.slice();
        cartChangeQueue = cartChangeQueue
          .catch(function () {})
          .then(function () {
            /* 🔴 Resolve line keys NOW — at POST time, inside the serialized
               queue — never at click time. Any earlier batch has fully
               settled by this point and __refreshRowLineKeys has already
               stamped every row with its CURRENT server key, so the payload
               can't carry a key the bundle-discount Function re-keyed away
               (the silent no-op that left "deleted" items alive). */
            var updates = {};
            queuedRows.forEach(function (row) {
              var target = row;
              if (!row.isConnected) {
                /* A full rebuild replaced this row's element mid-queue. The
                   shopper still asked for the line to go — find its rebuilt
                   twin and re-animate it out. */
                target = __relocateRowForRemoval(row);
                if (!target) return; // line already gone server-side
                target.__neswRemovePending = true;
                __animateRowOut(target);
                batchRows.push(target);
              }
              var k = target.dataset.lineKey;
              if (k) updates[k] = 0;
            });
            if (!Object.keys(updates).length) return null; // nothing valid left to remove
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates })
            });
          })
          .then(function (r) {
            /* Surface 429s / 5xxs instead of silently proceeding — the catch
               path restores truth via updateCart. */
            if (r && !r.ok) throw new Error('cart update failed: ' + r.status);
            return r ? r.json() : null;
          })
          /* 🔴 Don't trust the update.js cart totals — Shopify mis-reports
             automatic-discount totals on the mutation response (same bug as
             change.js). Re-fetch the authoritative /cart.js to reconcile. */
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            if (__cartOpsPending > 0) __cartOpsPending--;
            settled = true;
            batchRows.forEach(function (r) { r.__neswRemovePending = false; });
            /* EVERY settle refreshes keys (not just the last-op reconcile) so
               the next queued batch always POSTs current keys. */
            __refreshRowLineKeys(cart);
            if (typeof paintCartBadges === 'function') {
              paintCartBadges(cart.item_count);
            } else {
              document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
            }
            document.dispatchEvent(new CustomEvent('cart:change', { detail: cart }));
            /* Only the last settled op reconciles (burst-safe). */
            if (__cartOpsPending === 0) {
              var rebuilt = reconcileCartInPlace(cart);
              /* Self-heal: burst is over, server says items exist, but the
                 drawer shows none and nothing further is queued → the UI and
                 truth have fully diverged; force a rebuild instead of waiting
                 for the next drawer open to reveal it. */
              if (!rebuilt && cart.item_count > 0 &&
                  !cartItems.querySelector('.cart-item:not([data-removing])') &&
                  !__pendingRemoveRows.length) {
                updateCart();
              }
            }
          })
          .catch(function (err) {
            if (!settled && __cartOpsPending > 0) __cartOpsPending--;
            batchRows.forEach(function (r) { r.__neswRemovePending = false; });
            console.error('Remove error:', err);
            updateCart(); // restore truth on failure
          });
      }

      /* 🔴 Set EVERY piece of a bundle to the same quantity in ONE request.
         Driving each piece's own input instead looked like clean reuse and was
         wrong for the reason this file already documents two screens up: the
         bundle-discount Function RE-KEYS every line on every cart change, so
         the first piece's request invalidated the second piece's key. Measured
         2026-08-31: + went 1→2 correctly, a second + silently no-opped, and −
         split the tee into two separate x1 lines.
         So it follows the removal batch's shape exactly — one /cart/update.js,
         chained on cartChangeQueue, keys read at POST TIME after any earlier
         batch has settled and __refreshRowLineKeys has stamped current keys.
         Quantity 0 is left to the removal path, which owns the animation. */
      function queueBundleQuantity(group, qty) {
        if (!group || !(qty > 0)) return;
        __cartOpsPending++;
        var settled = false;
        cartChangeQueue = cartChangeQueue
          .catch(function () {})
          .then(function () {
            var updates = {};
            [].slice.call(group.querySelectorAll('.cart-bgroup__rows .cart-item:not([data-removing])'))
              .forEach(function (r) {
                var k = r.dataset.lineKey;
                if (k) updates[k] = qty;
              });
            if (!Object.keys(updates).length) return null;
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates })
            });
          })
          .then(function (r) {
            if (r && !r.ok) throw new Error('bundle qty update failed: ' + r.status);
            return r ? r.json() : null;
          })
          /* Same reason the removal path re-fetches: Shopify mis-reports
             automatic-discount totals on the mutation response. */
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            if (__cartOpsPending > 0) __cartOpsPending--;
            settled = true;
            __refreshRowLineKeys(cart);
            if (typeof paintCartBadges === 'function') {
              paintCartBadges(cart.item_count);
            } else {
              document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
            }
            document.dispatchEvent(new CustomEvent('cart:change', { detail: cart }));
            if (__cartOpsPending === 0) reconcileCartInPlace(cart);
          })
          .catch(function (err) {
            if (!settled && __cartOpsPending > 0) __cartOpsPending--;
            console.error('Bundle qty error:', err);
            updateCart(); // restore truth on failure
          });
      }

      function queueRowRemoval(row) {
        if (!row) return;
        if (row.getAttribute('data-removing')) return; // already queued / animating out
        var key = row.dataset.lineKey;
        if (!key) { // legacy row without a key → fall back to per-variant path
          var vid = row.dataset.variantId;
          if (vid) updateQuantity(vid, 0);
          return;
        }
        row.__neswRemovePending = true;
        __pendingRemoveRows.push(row);
        __animateRowOut(row);
        __optimisticTotalsFromRemaining();
        if (__removeFlushTimer) clearTimeout(__removeFlushTimer);
        __removeFlushTimer = setTimeout(__flushRemovals, 60);
      }

      /* Remove a whole locked bundle (or, with opts.onlyKey, just its optional
         add-on line). Queues every target row → they share one debounced flush,
         so the whole bundle drops in a single request/animation. */
      function removeBundleLines(bundleId, opts) {
        opts = opts || {};
        var esc = (window.CSS && CSS.escape) ? CSS.escape(bundleId) : bundleId;
        var rows = [].slice.call(cartItems.querySelectorAll('.cart-item[data-bundle-id="' + esc + '"]'));
        if (opts.onlyKey) {
          rows = rows.filter(function (r) { return r.dataset.lineKey === opts.onlyKey; });
        }
        /* Removing the WHOLE bundle → hide its rail group instantly. The rows'
           slide-out + the queued cart requests take a beat, and until the last
           row left the DOM the group shell (red rail + closing tag) lingered
           as a small red box (Jay, 2026-07-08). Only when every row of the
           group is going; an add-on-only removal keeps the group. */
        if (!opts.onlyKey && rows.length) {
          var grp = rows[0].closest('.cart-bgroup');
          if (grp && grp.querySelectorAll('.cart-item').length === rows.length) {
            grp.style.display = 'none';
          }
        }
        rows.forEach(queueRowRemoval);
      }

      /* ---- Compare-at bridge (see the NESW_COMPARE_AT comment above) ----
         /cart.js carries no compare_at_price, so every JS price render reads it
         out of this map instead. */

      /* THE one place that decides how a unit price reads, so the server markup,
         the full re-render and the in-place reconcile cannot drift apart.
         `was` is the highest honest reference: the compare-at when the merchant
         set one above the selling price, otherwise the pre-discount price. */
      function neswPriceHtml(orig, fin, variantId, fmt) {
        var cmp = (window.NESW_COMPARE_AT || {})[variantId] || 0;
        var was = (cmp > orig) ? cmp : orig;
        if (was > fin) {
          return '<s class="cart-item-price__was">' + Shopify.formatMoney(was, fmt) + '</s>' +
                 '<span class="cart-item-price__now">' + Shopify.formatMoney(fin, fmt) + '</span>';
        }
        return Shopify.formatMoney(orig, fmt);
      }

      /* Learn the compare-at for any variant we have not seen — one
         /products/<handle>.js per unknown PRODUCT, which returns every variant,
         de-duped while in flight and cached for the session. Resolves to true
         only if something new was learned, which is what stops the caller from
         repainting (and re-entering) forever. A failed lookup is swallowed and
         the line simply keeps its single price. */
      var __cmpPending = {};
      function ensureCompareAt(items) {
        var need = {};
        (items || []).forEach(function (it) {
          if (!it || it.variant_id == null || !it.handle) return;
          if (window.NESW_COMPARE_AT[it.variant_id] === undefined) need[it.handle] = true;
        });
        var handles = Object.keys(need);
        if (!handles.length) return Promise.resolve(false);
        return Promise.all(handles.map(function (h) {
          if (!__cmpPending[h]) {
            __cmpPending[h] = fetch('/products/' + encodeURIComponent(h) + '.js')
              .then(function (r) { return r.ok ? r.json() : null; })
              .then(function (p) {
                ((p && p.variants) || []).forEach(function (v) {
                  window.NESW_COMPARE_AT[v.id] =
                    (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : 0;
                });
              })
              .catch(function () {})
              .then(function () { delete __cmpPending[h]; });
          }
          return __cmpPending[h];
        })).then(function () { return true; });
      }

      /* Repaint every on-screen row's price from the map. Called once after a
         lazy fill lands, so a line added mid-session picks up its struck
         compare-at without a page reload. */
      function neswRepriceRows(cart, fmt) {
        var byKey = {};
        ((cart && cart.items) || []).forEach(function (it) { byKey[it.key] = it; });
        [].slice.call(cartItems.querySelectorAll('.cart-item')).forEach(function (row) {
          var it = byKey[row.dataset.lineKey];
          if (it) __applyRowPricing(row, it, fmt);
        });
        /* A compare-at that just landed changes the bundle's struck total too. */
        neswUpdateBundleSummaries();
      }

      /* Patch one row's price block + discount tags in place to match a fresh
         cart.js line (no innerHTML rebuild → no image reload / flash). */
      function __applyRowPricing(row, item, fmt) {
        var orig = (typeof item.original_price === 'number') ? item.original_price : item.price;
        var fin = (typeof item.final_price === 'number') ? item.final_price : orig;
        var priceEl = row.querySelector('.cart-item-price');
        if (priceEl) {
          priceEl.innerHTML = neswPriceHtml(orig, fin, item.variant_id, fmt);
        }
        var scU = (window.NESW_SALE_CENTS || {})[item.product_id] || 0;
        var tdU = orig - fin;
        var summerU = (scU > 0 && tdU > 0) ? Math.min(scU, tdU) : 0;
        var bundleU = tdU - summerU;
        var tagsHtml = (summerU > 0 || bundleU > 0)
          ? (summerU > 0 ? '<span class="cart-item-tag cart-item-tag--summer">Summer Sale</span>' : '') +
            (bundleU > 0 ? '<span class="cart-item-tag cart-item-tag--bundle">Bundle &amp; Save</span>' : '')
          : '';
        var tagsEl = row.querySelector('.cart-item-tags');
        if (tagsHtml) {
          if (!tagsEl) {
            tagsEl = document.createElement('div');
            tagsEl.className = 'cart-item-tags';
            if (priceEl && priceEl.parentNode) priceEl.parentNode.insertBefore(tagsEl, priceEl.nextSibling);
          }
          tagsEl.innerHTML = tagsHtml;
        } else if (tagsEl) {
          tagsEl.remove();
        }
        row.dataset.linePrice = item.final_line_price;
        row.dataset.originalLinePrice = item.original_line_price;
        row.dataset.qty = item.quantity;
      }

      /* Reconcile the drawer against an authoritative cart WITHOUT rebuilding the
         list: update remaining rows' prices/tags, drop removed rows, refresh
         totals — so no image reload / reflow flash (the post-delete "glitch").

         🔴 Match rows to cart lines by VARIANT ID, not line key. The bundle
         discount function RE-KEYS lines on every cart change (and the drawer's
         prefetch cache can paint from a slightly different key set), so line
         keys drift and key-matching would always miss → fall back to a full
         rebuild. Variant id is stable; we refresh each row's data-line-key to
         the fresh value so the NEXT removal targets the current line. Falls back
         to updateCart() only if a cart line has no matching row (an add).

         Cart lines whose only match is a row that's mid-removal (queued or
         in-flight, __neswRemovePending) are NOT "missing" — treating them as
         missing forced a full rebuild that resurrected the row as a live line
         and orphaned its queued removal. They're consumed as matches (key
         refreshed, kept animating) and the pending flush finishes the job.

         Returns true when it handed off to a full updateCart() rebuild, so the
         caller's self-heal check doesn't double-fetch. */
      function reconcileCartInPlace(cart) {
        if (!cart) return false;
        var footer = document.getElementById('cart-drawer-footer');
        var emptyMsg = document.getElementById('empty-cart-message');
        if (cart.item_count === 0) {
          cartItems.innerHTML = '';
          cartItems.style.display = 'none';
          if (emptyMsg) emptyMsg.style.display = 'block';
          if (footer) footer.style.display = 'none';
          renderFreeShipping(cart);
          cartDrawer.classList.remove('scrollable');
          return false;
        }
        var fmt = window.theme.settings.showPriceWithCurrency
          ? window.theme.settings.moneyFormatWithCurrency : window.theme.settings.moneyFormat;

        /* A line added during this session was never server-rendered, so its
           compare-at is not in the map yet. Learn it, then repaint once — the
           `learned` flag is what keeps this from looping, since a second pass
           finds nothing unknown. Deliberately not awaited: the rows paint now
           with their plain price and gain the struck compare-at a moment later,
           rather than the whole drawer waiting on a lookup. */
        ensureCompareAt(cart.items).then(function (learned) {
          if (learned) neswRepriceRows(cart, fmt);
        });

        /* Current on-screen rows (excluding ones animating out), grouped by
           variant id in DOM order. */
        var rows = [].slice.call(cartItems.querySelectorAll('.cart-item:not([data-removing])'));
        var rowsByVar = {};
        rows.forEach(function (r) {
          var v = String(r.dataset.variantId || '');
          (rowsByVar[v] = rowsByVar[v] || []).push(r);
        });
        /* Rows animating out whose removal is still queued/in-flight — their
           cart lines can legitimately still exist server-side right now. */
        var pendingByVar = {};
        [].slice.call(cartItems.querySelectorAll('.cart-item[data-removing]')).forEach(function (r) {
          if (!r.__neswRemovePending) return;
          var v = String(r.dataset.variantId || '');
          (pendingByVar[v] = pendingByVar[v] || []).push(r);
        });
        var freshByVar = {};
        cart.items.forEach(function (it) {
          var v = String(it.variant_id);
          (freshByVar[v] = freshByVar[v] || []).push(it);
        });

        var used = [], missing = false;
        Object.keys(freshByVar).forEach(function (v) {
          var items = freshByVar[v], rws = rowsByVar[v] || [];
          for (var i = 0; i < items.length; i++) {
            if (rws[i]) {
              __applyRowPricing(rws[i], items[i], fmt);
              rws[i].dataset.lineKey = items[i].key; // refresh drifted key
              used.push(rws[i]);
            } else {
              var pend = (pendingByVar[v] || []).shift();
              if (pend) {
                /* Line still exists but its row is mid-removal — keep the key
                   current so the pending flush removes the RIGHT line, and
                   don't drop the row (the flush settle will). */
                pend.dataset.lineKey = items[i].key;
                used.push(pend);
              } else { missing = true; }
            }
          }
        });
        if (missing) { updateCart(); return true; } // a line has no row (an add / a failed removal) → safe full render

        /* Drop any row not matched to a fresh line (the removed ones, incl. the
           still-animating rows). */
        [].slice.call(cartItems.querySelectorAll('.cart-item')).forEach(function (r) {
          if (used.indexOf(r) === -1) r.remove();
        });

        cartItems.style.display = 'block';
        if (emptyMsg) emptyMsg.style.display = 'none';
        if (footer) footer.style.display = 'block';
        renderDiscount(cart);
        renderShipping(cart);
        renderFreeShipping(cart);
        /* The pieces just changed price or quantity, so the line that stands in
           for them has to be recomputed — this path patches rows in place and
           never re-runs the grouping that built the summary. */
        neswUpdateBundleSummaries();
        if (cart.items.length > 3) cartDrawer.classList.add('scrollable');
        else cartDrawer.classList.remove('scrollable');
        return false;
      }

      /* V2 — In-drawer confirm before dropping a whole bundle. Returns a
         Promise<boolean>. Falls back to window.confirm if the markup is absent. */
      function neswConfirmBundleRemoval(count) {
        return new Promise(function (resolve) {
          var el = document.getElementById('cart-bundle-confirm');
          if (!el) {
            resolve(window.confirm('Remove the whole bundle? This removes all ' + count + ' items and the bundle savings.'));
            return;
          }
          var msg = el.querySelector('.cart-bconfirm__msg');
          if (msg) msg.textContent = 'These ' + count + ' pieces are bundled together for the discount. Removing one removes the whole bundle and its Bundle & Save savings.';
          var keepBtn = el.querySelector('.cart-bconfirm__keep');
          var remBtn = el.querySelector('.cart-bconfirm__remove');
          el.hidden = false;
          requestAnimationFrame(function () { el.classList.add('is-open'); });
          function done(val) {
            el.classList.remove('is-open');
            setTimeout(function () { el.hidden = true; }, 180);
            keepBtn.removeEventListener('click', onKeep);
            remBtn.removeEventListener('click', onRemove);
            el.removeEventListener('click', onBackdrop);
            document.removeEventListener('keydown', onKey);
            resolve(val);
          }
          function onKeep() { done(false); }
          function onRemove() { done(true); }
          function onBackdrop(e) { if (e.target === el) done(false); }
          function onKey(e) { if (e.key === 'Escape') done(false); }
          keepBtn.addEventListener('click', onKeep);
          remBtn.addEventListener('click', onRemove);
          el.addEventListener('click', onBackdrop);
          document.addEventListener('keydown', onKey);
          if (remBtn && remBtn.focus) remBtn.focus();
        });
      }

      // Add click event listener to all cart text elements
      if (cartTextElements.length > 0) {
        cartTextElements.forEach(cartText => {
          cartText.addEventListener('click', function(e) {
            e.preventDefault();
            openCartDrawer();
          });
        });
      }
    
      // Only add close cart listener if the button exists
      if (closeCart) {
        closeCart.addEventListener('click', closeCartDrawer);
      }
    
      // Close cart when clicking outside
      if (cartDrawer) {
        document.addEventListener('click', function(e) {
          if (!cartDrawer.classList.contains('open')) return;
          if (cartDrawer.contains(e.target)) return;
          if (Array.from(cartTextElements).some(el => el.contains(e.target))) return;
          /* 🔴 The quick-add sheet opens OVER the drawer but is rendered OUTSIDE
             it in the DOM, so every click inside it - the size pill, the Add
             button - satisfied "not inside the cart drawer" and closed the cart
             behind it. Adding from Pair It With therefore dumped the shopper back
             onto the page and cost them clicks to get to checkout, which is the
             exact opposite of what that row is for (Jay, 2026-09-10).
             Anything that deliberately opens over the drawer belongs on this list. */
          if (e.target.closest && e.target.closest('#cuq-drawer, .cuq-drawer')) return;
          closeCartDrawer();
        });
      }
    
      // Expose these functions globally
      window.openCartDrawer = openCartDrawer;
      window.updateCart = updateCart;

      /* Open the drawer on arrival from a cart link (Klaviyo abandoned-cart).
         Two entry points, both additive:
           ?cart_link_id=...  Shopify's cart permalink
                              (/cart/<variant>:<qty>?storefront=true) 302s here
                              with the cart rebuilt. 🔴 That redirect always
                              lands on /cart, and `return_to` is NOT honoured
                              (measured 2026-09-09), where sections/cart-drawer
                              .liquid:2 deliberately renders no drawer at all -
                              so this arm is a no-op TODAY and is here so it
                              works the moment that decision changes.
           #cart              works now, from any page that has the drawer.

         Never strips the URL and never changes what the page would otherwise
         do: every guard below simply falls through to today's behaviour, which
         is a working cart page. */
      (function openDrawerFromCartLink() {
        if (!cartDrawer) return;
        /* Not over checkout or the thank-you page. Theme JS is not normally
           served there, but a drawer thrown over a payment step is the one
           failure mode worth spending a line to make impossible. */
        if (/^\/(checkouts?|thank_you)\b/.test(location.pathname)) return;
        var fromLink = /[?&]cart_link_id=/.test(location.search);
        var fromHash = location.hash === '#cart';
        if (!fromLink && !fromHash) return;
        /* An empty cart would open onto the empty state, which is a worse
           landing than the page itself. __knownItemCount is stamped
           server-side onto #cart-drawer[data-item-count], so it is already
           correct at DOMContentLoaded - no fetch needed to decide this. */
        if (__knownItemCount < 1) return;
        openCartDrawer();
      })();

      /* Pair It With "+" button — server-rendered upsell row. The
         button is only shown for single-variant products (see Liquid:
         cd_can_direct_add), so a direct /cart/add.js is safe — no
         color/size guessing. Multi-variant products fall back to a
         link to the PDP, handled by the browser. The global
         nesw-cart-limit-guard wraps fetch so quantity caps apply. */
      document.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-cart-upsell-add]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        if (btn.classList.contains('is-adding')) return;
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        btn.classList.add('is-adding');
        /* Canonical add (fires Meta AddToCart + reconciles /cart.js +
           cart:change — the previous inline add did neither). */
        window.neswAddToCart(variantId, 1)
        .then(function () {
          btn.classList.remove('is-adding');
          btn.classList.add('is-added');
          btn.textContent = '✓';
          /* Re-run updateCart to refresh the drawer's visible line items + totals. */
          if (typeof updateCart === 'function') updateCart();
          setTimeout(function () {
            btn.classList.remove('is-added');
            btn.textContent = '+';
          }, 1400);
        })
        .catch(function (err) {
          console.error('Cart upsell add failed:', err);
          btn.classList.remove('is-adding');
        });
      });

      /* Header cart badge sync. The top nav (nesw-top-nav.liquid /
         nesw-top-icons.liquid) hardcodes its own `.cart-count` badge
         without rendering the cart-count.liquid listener, so without
         this nothing updated those badges until a page refresh.
         Mirrors the wishlist badge pattern — every cart mutation
         dispatches `cart:change`, every listener paints the badges. */
      function paintCartBadges(itemCount) {
        if (typeof itemCount !== 'number' || itemCount < 0) return;
        document.querySelectorAll('.cart-count').forEach(function (el) {
          if (el.textContent !== String(itemCount)) {
            el.textContent = itemCount;
            /* Restart the CSS countFlash animation without forcing a
               synchronous layout. Keyframes live in nesw-top-nav.liquid /
               cart-count.liquid (out of scope for this pass), so this stays
               CSS-driven rather than moving to el.animate(). The old
               remove → void offsetWidth → add idiom forced one synchronous
               reflow per badge per settle (up to 8 forced layouts measured
               per add, w3-3-inp.json); two nested rAFs let the class removal
               commit on its own paint before the class is re-added, with no
               style/layout read in between. */
            el.classList.remove('count-updated');
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                el.classList.add('count-updated');
              });
            });
            setTimeout(function () { el.classList.remove('count-updated'); }, 1500);
          }
          el.setAttribute('data-count', String(itemCount));
        });
      }
      window.updateCartCount = function (cart) {
        if (cart && typeof cart.item_count === 'number') {
          paintCartBadges(cart.item_count);
          return;
        }
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (c) { paintCartBadges(c.item_count); })
          .catch(function () {});
      };
      document.addEventListener('cart:change', function (e) {
        if (e && e.detail && typeof e.detail.item_count === 'number') {
          paintCartBadges(e.detail.item_count);
        } else {
          window.updateCartCount();
        }
      });

      /* V2 — Re-filter the "Pair It With" recommender row on every
         cart change. The Liquid SSR already excludes in-cart products
         at page load, but the row is NEVER re-rendered after that —
         so when the shopper adds something via AJAX, the just-added
         product still sat in the recommender until a full page
         reload. This hides any card whose product is now in the
         cart. Safe-mode: if hiding would empty the row entirely
         (almost everything in cart), it stops hiding instead. */
      function __cdFilterUpsellRow(cart) {
        if (!cart || !Array.isArray(cart.items)) return;
        /* Hide the whole "Pair It With" block when the cart is empty —
           an upsell row on an empty cart reads as broken. Toggling display
           (rather than removing it) keeps the SSR'd row in the DOM so it
           reappears the moment an item is added. */
        var __upsellEmpty = cart.items.length === 0;
        document.querySelectorAll('.cart-drawer-upsell-wrap, .cart-page-upsell-wrap').forEach(function (w) {
          w.style.display = __upsellEmpty ? 'none' : '';
        });
        if (__upsellEmpty) return;
        var cartPids = Object.create(null);
        cart.items.forEach(function (it) {
          if (it && it.product_id != null) cartPids[String(it.product_id)] = true;
        });
        var rows = document.querySelectorAll('.cart-drawer-upsell-wrap, .cart-page-upsell-wrap');
        rows.forEach(function (row) {
          var cards = Array.prototype.slice.call(row.querySelectorAll('.product-recommendations-card'));
          var visibleCards = cards.filter(function (c) {
            var qabtn = c.querySelector('.related-quick-add-btn');
            var pid = qabtn && qabtn.dataset.productId;
            return !(pid && cartPids[String(pid)]);
          });
          /* If hiding the in-cart ones would leave nothing visible
             (cart contains every recommended product), keep them all
             — better to show duplicates than an empty upsell row. */
          if (visibleCards.length === 0) {
            cards.forEach(function (c) { c.style.removeProperty('display'); });
            return;
          }
          cards.forEach(function (c) {
            var qabtn = c.querySelector('.related-quick-add-btn');
            var pid = qabtn && qabtn.dataset.productId;
            if (pid && cartPids[String(pid)]) {
              c.style.display = 'none';
            } else {
              c.style.removeProperty('display');
            }
          });
        });
      }
      document.addEventListener('cart:change', function (e) {
        if (e && e.detail && Array.isArray(e.detail.items)) {
          __cdFilterUpsellRow(e.detail);
        } else {
          /* No detail attached → fetch fresh cart state. */
          fetch('/cart.js').then(function (r) { return r.json(); }).then(__cdFilterUpsellRow).catch(function () {});
        }
      });

      /* Patch updateCart so when the drawer refreshes its contents
         (called by openCartDrawer + qty changes) the header badges
         get the new count from the same /cart.js payload, without a
         second fetch. */
      var __origUpdateCart = updateCart;
      updateCart = function () {
        /* 🔴 Fetch /cart.js ONCE and hand the result to __origUpdateCart
           instead of letting it fetch again — this used to cost 2 round
           trips per call (dispatch/badge-paint measured at +96-99ms,
           __origUpdateCart's OWN /cart.js at +98-101ms, w3-3-inp.json), and
           this wrapper IS what every internal updateCart()/window.updateCart()
           call in this file resolves to once this assignment runs. External
           callers (window.updateCart() with no args — product-add-to-cart.js,
           nesw-cart-upsell-quick-add.js, nesw-row-quickadd-drawer.liquid) are
           unaffected: same one badge-paint + cart:change + full render, one
           fetch instead of two. On a failed fetch, `cart` is null and
           __origUpdateCart(false, undefined) behaves exactly like the old
           bare __origUpdateCart() call — same fallback, unchanged. */
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            paintCartBadges(cart.item_count);
            document.dispatchEvent(new CustomEvent('cart:change', { detail: cart }));
            return cart;
          })
          .catch(function () { return null; })
          .then(function (cart) { return __origUpdateCart(false, cart || undefined); });
      };
      window.updateCart = updateCart;

      // Wallet web component is hidden via CSS above. No JS filter
      // needed — Shadow DOM blocks per-button manipulation anyway.
    
      // FOMO Timer functionality
      function startFomoTimer(endTime, display) {
        const timerText = document.getElementById('fomo-timer-text');
        
        function updateTimer() {
          const now = new Date().getTime();
          const distance = endTime - now;
    
          if (distance < 0) {
            clearInterval(window.fomoTimerInterval);
            display.textContent = "Offer expired!";
            timerText.classList.add('fomo-timer-shake');
            
            // Show message for 3 seconds, then restart timer
            setTimeout(() => {
              timerText.classList.remove('fomo-timer-shake');
              initFomoTimer(); // Reinitialize the timer
            }, 3000);
            
            return;
          }
    
          const hours = Math.floor(distance / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
          display.textContent = `${hours}h ${minutes}m ${seconds}s`;
        }
    
        updateTimer(); // Call once immediately to avoid delay
        window.fomoTimerInterval = setInterval(updateTimer, 1000);
      }
    
      function initFomoTimer() {
        const display = document.querySelector('#timer-countdown');
        if (display && window.theme.settings.show_fomo_timer) {
          clearInterval(window.fomoTimerInterval);
          
          const now = new Date().getTime();
          let endTime = localStorage.getItem('fomoTimerEnd');
          const duration = window.theme.settings.fomo_timer_duration * 60 * 60 * 1000; // Convert hours to milliseconds
          
          if (!endTime || now > parseInt(endTime)) {
            endTime = now + duration;
            localStorage.setItem('fomoTimerEnd', endTime.toString());
          } else {
            // If the timer hasn't expired, but the duration has changed, adjust the end time
            const remainingTime = parseInt(endTime) - now;
            if (remainingTime > duration) {
              endTime = now + duration;
              localStorage.setItem('fomoTimerEnd', endTime.toString());
            }
          }
          
          startFomoTimer(parseInt(endTime), display);
        }
      }
    
      // Call initFomoTimer when the cart drawer is opened
      document.addEventListener('cart:open', function() {
        initFomoTimer();
      });
    
      // Also initialize the timer when the page loads
      initFomoTimer();
    

      function removeItem(variantId) {
        showCartSkeleton();
        
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 0
          })
        })
        .then(function (response) {
          /* Route 422/429/5xx into the catch (which restores the row / hides
             the skeleton) instead of parsing an error body as if it were a
             valid cart — a non-ok body has no item_count and would blank the
             badge. Mirrors the guard on the V2 /cart/update.js batch path. */
          if (!response.ok) throw new Error('cart change failed: ' + response.status);
          return response.json();
        })
        .then(cart => {
          // Dispatch cart:change event after successful removal
          document.dispatchEvent(new CustomEvent('cart:change', { 
            detail: cart 
          }));
          
          updateCart();
        })
        .catch(error => {
          console.error('Error:', error);
          hideCartSkeleton();
        });
      }

      // Also in the quantity change function
      function updateItemQuantity(variantId, quantity) {
        showCartSkeleton();
        
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity
          })
        })
        .then(function (response) {
          /* Route 422/429/5xx into the catch (which restores the row / hides
             the skeleton) instead of parsing an error body as if it were a
             valid cart — a non-ok body has no item_count and would blank the
             badge. Mirrors the guard on the V2 /cart/update.js batch path. */
          if (!response.ok) throw new Error('cart change failed: ' + response.status);
          return response.json();
        })
        .then(cart => {
          // Dispatch cart:change event after quantity update
          document.dispatchEvent(new CustomEvent('cart:change', { 
            detail: cart 
          }));
          
          updateCart();
        })
        .catch(error => {
          console.error('Error:', error);
          hideCartSkeleton();
        });
      }
    });
  })();
